const en_translation = {
    Home: "Home",
    AboutUs: "About Us",
    Products: "Products",
    Blog: "Blog",
    Contact: "Contact",
    ContactUs: "Contact Us",
    SetsOfElectricalEquipments: "Sets of Electrical Equipments",
    Transformers: "Transformers",
    PrefabricatedSubstations: "Prefabricated Substations",
    IronAccessories: "Iron Accessories",
    AnnualCapacity: "Annual Capacity",
    heroTitle: "Transforming Power with Integrity and Innovation",
    customized: "Customized",
    ourProducts: "Our Products",
    detail: "Detail",
    QUALITYASSURANCE: "QUALITY ASSURANCE",
    QualificationCertificates: "Qualification Certificates",
    BlogPost: "Blog Post",
    LatestNewsFromBlog: "Latest News From Blog",
    HONORABLECUSTOMER: "HONORABLE CUSTOMER",
    Weareworkwithtopbrand: "We are work with top brand",
    ProductCategory: "Product Category",
    AllProducts: "All Products",
    OperatingConditions: "Operating Conditions",
    Features: "Features",
    technicalParameters: "technical Parameters",
    Product: "Product",
    Type: "Type",
    Model: "Model",
    Design: "Design",
    Duration: "Duration",
    UpdateDate: "Update Date",
    RelatedProducts: "Related Products",
    ProductOverview: "Product Overview",
    LatestNews: "Latest News",
    READMORE: "READ MORE...",
    Back: "Back",
    By: "By",
    Share: "Share: ",
    facebook: "facebook",
    twitter: "twitter",
    linkedin: "linkedin",
    pinterest: "pinterest",
    PreviousPost: "Previous Post",
    Thisisalreadythefirstpost: "This is already the first post.",
    NextPost: "Next Post",
    Tags: "Tags: ",
    NoResults: "Your search did not match any blogs",
    NoResultsHints: "Suggestions:",
    Hint1: "Make sure that all words are spelled correctly.",
    Hint2: "Try tags at the right side.",
    singleResult: " result",
    multipleResults: " results",
    Thisisalreadythelastpost: "This is already the last post.",
    RelatedPosts: "Related Posts",
    SearchHere: "Search Here",
    SearchPost: "Search Post..",
    lengthError: "keyword is empty or too long",
    typeError: "Keyword includes invalid character",
    by: "by: ",
    OopsPageNotFound: "Oops! Page Not Found!",
    SorryNotFound: "We’re sorry but we can’t seem to find the page you requested. This might be because you have typed the web address incorrectly.",
    BacktoHome: "Back to home",
    NotSupportVideo: "Your browser does not support HTML5 video.",
    SomethingWentWrong: "Something went wrong!",
    ContactAdministratorOrGoBackHome: "Please contact the administrator or go back to home page.",
    contactUspage: {
        AddressTitle: "Address",
        SpecificAddress: "No.1 Yansha Road, Yanji Diamond Industrial Zone, Yanji Town, Ezhou City, Hubei Province, China.",
        ChatwithUs: "Chat with Us",
        Email: "Email: ",
        WeChat: "WeChat",
        CallUs: "Call Us",
        Tel: "Tel: ",
        Fax: "Fax: ",
        Phone: "Phone: ",
        OnlineQuote: "Online Quote",
        OnlineQuoteDescription: "To help us provide you with the best electrical solution to your needs quickly, please provide as much information as possible and we will get back to you promptly.",
    },
    contactForm: {
        FullName: "Full Name",
        YourName: "Your Name",
        Email: "Email",
        YourEmail: "Your Email",
        Phone: "Phone",
        YourPhone: "Your Phone",
        Company: "Company / Institution",
        YourCompany: "Your Company / Institution",
        HowDidYouFindUs: "How Did You Find Us",
        Choose: "Choose",
        ExistingCustomer: "Existing Customer",
        Google: "Google",
        Advertisement: "Advertisement",
        WordofMouth: "Word of Mouth",
        Other: "Other",
        BestTimetoCall: "Best Time to Call",
        AnyTime: "Any Time",
        Morning: "Morning",
        Afternoon: "Afternoon",
        Message: "Message",
        MessagePlaceHolder: "If you have any special requirements, let us know and we will get back to you soon.",
        SubmitNow: "Submit Now",
        Verify: "I am not a robot",
        SubmitError: "Oops! There was a problem submitting your form, please contact us by telephones above",
        SubmitSuccess: "Thanks for your submission! We'll get back to you soon",
        VerificationError: "Verification code loading error",
        Thankyou: "Thank you!",
        WehaveReceivedYourMessage: "We have receivied your message and will get back to you as soon as possible!",
        SubmitAnother: "Submit another quote",
        GobackHome: "Go back to home page"
    },
    missionVissionPage: {
        transformersSubstationsTitle: "Our Transformers and Substations in Hubei and Beyond",
        clienteleSatisfaction: "Current Clientele and Customer Satisfaction",
        currentCustomersDescription: "Our current customers include CSCEC (China State Construction Engineering Corporation), MCC (China First Metallurgical Group), CACCC (China Railway Beijing Engineering Group), State Grid and many others. All have expressed a high level of satisfaction with our products and services.",
        operationalLandmarksDescription: "Our transformers and prefabricated substation are prominently operational across several landmarks in Ezhou, such as:",
        customTransformersInfo: "We have also manufactured custom transformers and substations such as 1250kVA 33/0.4kV Box-type Substation, 750kVA 12/0.44kV American-style Transformer and 440V Low Voltage Switchgear, 400kVA 33/0.4kV Oil-immersed Transformer, Voltage Transformer and 800kVA 15/0.4kV Oil-immersed Transformer for European, African and South Asian customers.",
        qualityCornerstoneTitle: "Quality Forms the Cornerstone of Our Brand",
        businessTrustSubtitle: "A business that you can trust",
        ximaiQualityImportance: "Ximai Electric understands that the key factor for sustainable business growth is quality. Ximai Electric adopts the 6S management model and employs exquisite craftsmanship to produce high-quality products that meet the needs of a wide range of customers. Ximai Electric's quality management system complies with ISO9001, its environmental management system meets ISO4001 standards, and its occupational health and safety management system is OHSAS18001 certified. Its low-voltage complete set equipment products have received 3C certification, and all other products have passed the qualified tests of the National Quality Supervision and Inspection Center, along with holding national patents. Furthermore, we have been approved as a qualified supplier by the State Grid, Ximai Electric has achieved substantial success in various project bids within the State Grid since 2006.",
        safetyFirstQualityOriented: "With \"Safety First, Quality-Oriented, Customer-Centric\" as our mission, Ximai Electric has been honored for multiple consecutive years with the \"Contract-Abiding and Trustworthy Enterprise\" award in both Hubei Province and the city of Ezhou. Additionally, the Ximai Electric logo has been recognized as a famous trademark in both Hubei Province and the city of Ezhou.",
        landmarks: [
            'Ezhou Central Hospital',
            'Huahu Airport, Ezhou',
            'Ezhou Police Station',
            'Ezhou CDC (Chinese Center for Disaese Control and Prevention)',
            "Ezhou Aerotropolis People's Hospital",
            'Ezhou Third Hospital',
            'Ezhou University'
        ],
    },
    About4: {
        title: "Everything about Our Company",
        description1: "Located in the ancient city of Ezhou, Ximai Electrical Equipment Co., Ltd. (\"Ximai Electrical\") was established in 2006. Our facility covers 40,000 square meters, with a 20,000-square-meter factory floor. We boast an annual production capacity of 18,000 sets of high and low-voltage equipment, 9,000 transformers, 4,500 prefabricated substations, and 10,000 tons of iron accessories. Holding foreign trade rights, Ximai Electrical utilizes its smart manufacturing capabilities and brand strength to distribute products across China and international markets, including Asia and Africa.",
        description2: "We specialize in the production of 10KV energy-saving transformers, available in dry-type, oil-immersed, and amorphous alloy variations. Our product line also includes <span>electric vehicle charging stations</span>, <span>low-voltage switchboards</span> such as GGD, GCS, and GGJ, as well as <span>high-voltage cabinets</span> like KYN-28 and HXGN-12. In addition, we offer <span>high-voltage ring main units</span>, both high and low-voltage metering cabinets, and <span>European and American styles of charging station transformers</span>.",
        button: "Enquire Now"
    },
    testimonial: {
        sectionSubtitle: "INTERNATIONAL CLIENT TESTIMONIAL",
        sectionTitle: "Best Word Our Clients",
        words: {
            '01': {
                Des: "Working with Ximai Electrical was an exceptional experience. We inquired about voltage transformers and received not only a competitive quote but also detailed blueprints. We placed the order without a hitch, and received high-quality products in September 2019, right on schedule. Highly recommended!",
                Title: 'Pavel Livandovskyy',
                Sub: "HIGH VOLTAGE UNION-RZVA"
            },
            '02': {
                Des: "We searched for suppliers online and visited multiple factories, but Ximai Electrical truly stood out. Their competitive pricing and strong capabilities impressed us. After confirming the blueprints, we placed an order for a 1250kVA 33/0.4kV substations. The delivery arrived in August 2019, exactly as planned. Couldn't be more satisfied!",
                Title: 'Henos Dereb',
                Sub: "Manager"
            },
            '03': {
                Des: "We found Ximai Electrical online and their professionalism caught our eye immediately. Not only did they offer competitive pricing, but their service level was also exceptional. We had multiple options but their reputation sealed the deal. Received shipment and all processes are smooth.",
                Title: 'Jesse Mouttet',
                Sub: "Merketer"
            }
        }
    },
    footer: {
        address: "No.1 Yansha Road, Yanji Diamond Industrial Zone, Yanji Town, Ezhou City, Hubei Province, China.",
        tel: "Tel: (0086) 0711-5921007",
        fax: "Fax: (0086) 0711-5921066",
        email: "Email: hbxmdq@163.com",
        company: "Company",
        aboutCompany: "About company",
        products: "Our Products",
        contactUs: "Contact us",
        visionValues: "Vision & Values",
        recentPost: "Recent Post",
        copyright: "Copyright &copy; 2022 //  All Right Reserved by",
        history: "History",
        awards: "Awards",
        leadership: "Leadership",
        ContactUsNow: "Contact Us Now"
    },
    HeaderTopbar3: {
        address: "1 Yansha Road, Ezhou"
    },
    AboutHome: {
        heroTitle1: "We are",
        heroTitleHighlight1: "designing",
        heroTitle2: "and",
        heroTitleHighlight2: "manufacturing",
        heroTitle3: "transformers",
        heroTitle4: "and",
        heroTitleHighlight3: "electrical equipments",
        description: "Ximai spans 40,000 square meters with a newly built factory of 20,000 square meters. It has an annual production capacity of 8,000 sets of high and low voltage equipment, 6,000 transformers, 2,000 box-type substations, and 10,000 tons of iron accessories. The company's intelligent energy-saving products and core technologies are improving year by year. Ximai has achieved impressive results in the National Grid, power generation, transportation, and intelligent manufacturing sectors, and its equipment products have received unanimous praise from relevant national departments and users.",
        exploreBtn: "Explore"
    },
    service: {
        "transformerTitle": "Transformer",
        "transformerDescription": "Including dry-type, oil-immersed and amorphous alloy transformer",
        "switchgearTitle": "Switchgear",
        "switchgearDescription": "Including KYN28, GCS, KYN28A-12 and GGD type.",
        "substationTitle": "Prefabricated Substation",
        "substationDescription": "Box-type Substation (for both European and American style).",
        "accessoriesTitle": "Accessories",
        "accessoriesDescription": "Including electric iron, aerial insulation, transformer and line fittings, etc."
    },
    Qualification: {
        "1": {
            "title": "WSF Certificate",
            "subTitle": "Transformers, Substations, Switchgear and Iron accessories Registration"
        },
        "2": {
            "title": "WSF Certificate",
            "subTitle": "Transformers, Substations, Switchgear and Iron accessories Registration"
        },
        "3": {
            "title": "WSF Certificate",
            "subTitle": "Transformers, Substations, Switchgear and Iron accessories Registration"
        },
        "4": {
            "title": "CCC Certificate",
            "subTitle": "Quality Assurance of Power Distribution in Public Networks"
        },
        "5": {
            "title": "CCC Certificate",
            "subTitle": "Quality Assurance of Low-voltage Switchgear Assemblies"
        },
        "6": {
            "title": "CCC Certificate",
            "subTitle": "Quality Assurance of Low-voltage Switchgear Assemblies"
        },
        "7": {
            "title": "CCC Certificate",
            "subTitle": "Quality Assurance of Distribution Boards"
        },
        "8": {
            "title": "CCC Certificate",
            "subTitle": "Quality Assurance of Low-voltage Switchgear Assemblies"
        },
        "9": {
            "title": "CCC Certificate",
            "subTitle": "Quality Assurance of Low-voltage Switchgear Assemblies"
        }
    },
    Patents: {
        '1': {
            "title": "Appearance Patent",
            "subTitle": "Distribution Transformer"
        },
        '2': {
            "title": "Utility Model Patent",
            "subTitle": "Power Distribution Box P1"
        },
        '3': {
            "title": "Utility Model Patent",
            "subTitle": "Power Distribution Box P2"
        },
        '4': {
            "title": "Utility Model Patent",
            "subTitle": "Low Voltage Switchgear P1"
        },
        '5': {
            "title": "Utility Model Patent",
            "subTitle": "Low Voltage Switchgear P2"
        },
        '6': {
            "title": "Utility Model Patent",
            "subTitle": "Close Structure Switchgear P1"
        },
        '7': {
            "title": "Utility Model Patent",
            "subTitle": "Close Structure Switchgear P2"
        },
        '8': {
            "title": "Utility Model Patent",
            "subTitle": "Lightning Protection Type Transformer Cabinet P1"
        },
        '9': {
            "title": "Utility Model Patent",
            "subTitle": "Lightning Protection Type Transformer Cabinet P2"
        },
        '10': {
            "title": "Utility Model Patent",
            "subTitle": "waterproof type Box type substation p1"
        },
        '11': {
            "title": "Utility Model Patent",
            "subTitle": "waterproof type Box type substation p2"
        },
        '12': {
            "title": "Utility Model Patent",
            "subTitle": "Shock absorbing type transformer p1"
        },
        '13': {
            "title": "Utility Model Patent",
            "subTitle": "Shock absorbing type transformer p2"
        },
        '14': {
            "title": "Utility Model Patent",
            "subTitle": "Detachable type Transformer bottom frame p1"
        },
        '15': {
            "title": "Utility Model Patent",
            "subTitle": "Detachable type Transformer bottom frame p2"
        },
        '16': {
            "title": "Utility Model Patent",
            "subTitle": "Cooling structure of new dry-type transformer p1"
        },
        '17': {
            "title": "Utility Model Patent",
            "subTitle": "Cooling structure of new dry-type transformer p2"
        },
        '18': {
            "title": "Utility Model Patent",
            "subTitle": "Assembled multifunctional low voltage distribution box p1"
        },
        '19': {
            "title": "Utility Model Patent",
            "subTitle": "Assembled multifunctional low voltage distribution box p2"
        }
    },
    ProductCategories: {
        "PrefabricatedSubstation": "Prefabricated Substation",
        "Switchgear": "Switchgear",
        "Transformer": "Transformer",
        "showcategories": "Show Categories",
        "VoltageTransformer": "Voltage Transformer",
        "CurrentTransformer": "Current Transformer",
        "Inverter": "Inverter",
        "VoltageRegulator": "Voltage Regulator",
    },
    products: {
        0: {
            "name": "European-style Prefabricated Box-type Substation",
            "model": "YB£-12/0.4-£",
            "category": "Prefabricated Substation",
            "shortDescription": "Widely Used in urban areas, high-rises, industrial sites, highways, oil fields and various public spaces for temporary power.",
            "intro": "Widely used in urban grid renovation, residential areas, high-rise buildings, industrial and mining, hotels, shopping malls, airports, railways, oil fields, docks, highways, and other indoor and outdoor locations for temporary power facilities.",
            duration: "7 days",
            updateDate: "27 Sept, 2023",
            "features": {
                "0": "Integration of high-voltage switchgear, transformers, and low-voltage switchgear, providing a complete set",
                "1": "Comprehensive high and low voltage protection, safe and reliable operation, and easy maintenance",
                "2": "Compact footprint, cost-effective, short production cycle, and easily mobile",
                "3": "Flexible wiring options",
                "4": "Unique Structure: Unique honeycomb double-layer (composite board) shell that is sturdy, heat-insulating, ventilating, aesthetically pleasing, and offers a high level of protection. Shell materials include stainless steel, aluminum alloy, cold-rolled plate, and colored steel plate options",
                "5": "Various Types: General type, villa type, compact type, etc.",
                "6": "The high-voltage ring network cabinet can be equipped with a network automation terminal (FTU) for reliable detection of short circuits and single-phase ground faults. Equipped with 'four remote' functions, facilitating the upgrading of distribution network automation"
            },
            "condition": {
                "0": "Altitude not exceeding 1000m",
                "1": "Ambient temperature: -25℃~+40℃",
                "2": "Relative humidity: Daily average value not exceeding 95%, monthly average value not exceeding 90%",
                "3": "Installation locations: Locations with no risk of fire, explosion, conductive dust, corrosive gases, and severe vibrations. If the conditions exceed these, the user may consult with our company"
            }
        },
        "1": {
            "name": "American-style Prefabricated Box-type Substation",
            "model": "ZGS",
            "category": "Prefabricated Substation",
            "shortDescription": "Advanced tech meets local needs in our compact, easy-to-install product, offering low noise, high capacity, and full protection for various settings.",
            "intro": "This product is developed by absorbing the latest advanced technology from abroad and combining it with domestic practical situations. It features small size, easy installation and maintenance, low noise, low loss, anti-theft, high overload capacity, and full protection. It is suitable for newly built residential areas, green belts, parks, station hotels, construction sites, airports, etc.",
            duration: "10 days",
            updateDate: "10 June, 2025",
            "features": {
                "0": "Fully insulated, fully sealed, maintenance-free, and ensures personal safety",
                "1": "Compact structure, its volume is only 1/3-1/5 of European substations of the same capacity, with lower height",
                "2": "The split box structure can be adopted to avoid pollution of transformer oil",
                "3": "High-voltage side uses dual fuses for full-range protection, significantly reducing costs",
                "4": "Suitable for both ring networks and terminals, and the cable head can be urgently inserted and removed under a load current of 200A",
                "5": "The box adopts a honeycomb double-layer composite board, which has heat insulation and heat dissipation functions",
                "6": "The low-voltage side is equipped with an electronic phase-loss protector, which can quickly disconnect the main incoming switch when an abnormal voltage occurs in the system",
                "7": "The high-voltage side has oil-immersed load switches or SF6 load switches, which can be electrically upgraded to lay the foundation for distribution network automation",
                "8": "Uses oil-immersed S9 transformers or better-performing S11 series transformers"
            },
            "condition": {
                "0": "Altitude not exceeding 1000m",
                "1": "Ambient temperature: -35℃~+40℃",
                "2": "Relative humidity: Daily average value not exceeding 95%, monthly average value not exceeding 90%",
                "3": "Installation locations: Locations without the risk of fire, explosion, corrosive gases, and well-ventilated areas, ground inclination not exceeding 3°"
            }
        },
        "2": {
            "name": "Armored Movable Enclosed Switchgear",
            "model": "KYN28A-12",
            "category": "Switchgear",
            "duration": "3 days",
            "updateDate": "27 Sept, 2023",
            "type": "Indoor AC Metal-Clad Mid-mounted Switchgear",
            "shortDescription": "Compact, easy-to-install AC metal-clad product with low noise and high capacity, ideal for new residential areas and public spaces.",
            "intro": "KYN28A-12 type indoor AC metal-clad mid-mounted switchgear is suitable for three-phase AC systems with a rated voltage of 12kV and a rated frequency of 50Hz. It is used for receiving and distributing electrical energy and for controlling, protecting, and monitoring circuits.",
            "features": {
                "0": "The switchgear is designed according to GB3906-91 for armored metal-enclosed switchgear. It is mainly composed of a cabinet and mid-mounted drawable parts (i.e., trolleys). The cabinet is divided into four separate compartments, with an outer shell protection level of IP4X. The protection level between the compartments and when the circuit breaker chamber door is open is IP2X.",
                "1": "It provides overhead inlets and outlets, cable inlets and outlets, and other functional schemes. After being arranged and combined, it forms a complete power distribution system device.",
                "2": "Installation, debugging, and maintenance of this switchgear can be performed from the front. Therefore, it can be back-to-back, form double rows, and be installed against the wall, improving the safety and flexibility of the switchgear and reducing its footprint."
            },
            "condition": {
                "0": "Ambient air temperature: Maximum temperature +40℃, minimum temperature -15℃",
                "1": "Relative humidity: Daily average relative humidity: ≤95%; daily average water vapor pressure does not exceed 2.2KPa; monthly average relative humidity: <90%; monthly average water vapor pressure does not exceed 1.8KPa",
                "2": "Altitude: Below 1000m",
                "3": "Seismic intensity: Not exceeding 8 degrees",
                "4": "The surrounding air should not be significantly polluted by corrosive or flammable gases, water vapor, etc.",
                "5": "No severe vibration locations",
                "6": "If used under conditions beyond those stipulated by GB3906, it should be negotiated between the user and the company."
            }
        },
        "3": {
            "name": "Low Voltage Switchgear",
            "model": "GGD",
            "category": "Switchgear",
            "duration": "3 days",
            "updateDate": "27 Sept, 2023",
            "shortDescription": "High-capacity AC cabinet for energy conversion and distribution in various sectors; features flexibility and high protection.",
            "type": "AC Low Voltage Power Distribution Cabinet",
            "intro": "The GGD AC low voltage power distribution cabinet is suitable for power plants, substations, industrial and mining enterprises, and other electricity users with a 50Hz AC system, rated working voltage of 380V, and rated working current of 5000A. It is used for the conversion, distribution, and control of electrical energy for power, lighting, and distribution equipment. The product has high breaking capacity, good dynamic thermal stability, flexible electrical schemes, convenient combination, strong practicality, novel structure, and high protection level. It can be used as an upgraded product for low-voltage switchgear.",
            "features": {
                "0": "High breaking capacity and good dynamic thermal stability",
                "1": "Flexible electrical schemes and convenient combinations",
                "2": "Strong practicality, novel structure, and high protection level",
                "3": "Can be used as an upgraded product for low-voltage switchgear"
            },
            "condition": {
                "0": "Ambient air temperature not higher than +40℃ and not lower than -5℃. The average temperature within 24 hours should not exceed +35℃",
                "1": "Indoor installation, the altitude of the installation location should not exceed 2000m",
                "2": "Relative humidity not exceeding 50% at the highest temperature of +40℃, and a larger relative humidity is allowed at lower temperatures (e.g., 90% at +20℃). The impact of condensation due to temperature changes should be considered",
                "3": "The inclination of the equipment when installed should not exceed 5%",
                "4": "The equipment should be installed in a place without severe vibration and impact, and where the electrical components are not subject to corrosion",
                "5": "For special requirements, negotiate with the manufacturer"
            },
            table: {
                headers: [
                    "Model",
                    "Rated Voltage (V)",
                    "Rated Current (A)",
                    "Rated Short-Circuit Breaking Current (KA)",
                    "Rated Short-Time Withstand Current (1S) (KA)",
                    "Rated Peak Withstand Current (KA)"
                ],
                rows: [
                    ["CCD1", "380", "A1000", "15", "15", "30"],
                    ["", "", "B600(630)", "", "", ""],
                    ["", "", "C400", "", "", ""],
                    ["GGD2", "380", "A1500(1600)", "30", "30", "63"],
                    ["", "", "B1000", "", "", ""],
                    ["", "", "C600", "", "", ""],
                    ["GGD3", "380", "A3200", "50", "50", "105"],
                ],
            },
        },
        "4": {
            "name": "Low Voltage Reactive Power Compensation Device",
            "model": "GGJ",
            "category": "Switchgear",
            "duration": "3 days",
            "updateDate": "27 Sept, 2023",
            "shortDescription": "Smart, energy-efficient device for reactive power compensation in low-voltage systems, enhancing power factors and minimizing losses.",
            "intro": "Designed with the aid of computer technology, our GGJ Low Voltage Reactive Power Compensation Device features intelligent tracking and compensation for reactive power. It's a state-of-the-art, energy-efficient solution that improves power factors and reduces losses in low voltage electrical systems.",
            "features": {
                "0": "Smart Controller Control.",
                "1": "Full-featured, reliable performance with an automatic compensation method.",
                "2": "Can enhance the power factor to above 0.9.",
                "3": "Real-time display of the power grid's power factor; display range: lagging (0.00-0.99) to leading (0.00-0.99).",
                "4": "Equipped with comprehensive protection features including over-voltage, harmonic overloading, overcompensation, system failures, phase failures, and overload.",
                "5": "Retains set parameters; system outages won't lead to parameter loss. Once the power grid is back to normal, it auto-enters operation mode, eliminating the need for personnel oversight.",
                "6": "Depending on the power grid load balance, it can use phase compensation or mixed compensation.",
                "7": "Strong anti-interference capability, able to withstand direct interference pulses of 2000V amplitude from the power grid, exceeding national professional standards.",
                "8": "Real-time measurement and on-the-hour recording of three-phase voltage, current, frequency, active power, reactive power, power factor, active energy, and reactive energy on the transformer's low voltage side. Measures total harmonic distortion of voltage and current and records 2-25 harmonic content.",
                "9": "Equipped with RS-232 and RS-485 interfaces; supports handheld computer data recording. Also features remote communication capabilities for wireless meter reading, device testing, parameter setting, and real-time measurement data and recorded data retrieval.",
                "10": "Data analysis functionality: Processes and statistically queries operational load data; comprehensively analyzes power supply quality, calculating voltage pass rate, power supply load rate, reliability, and maximum load rate. Provides time-segmented queries of power factor, active power, and reactive power. Illustrates curves of phase voltage, current, and power factor, and can print comprehensive analysis and statistical reports."
            },
            "technicalParameters": {
                "0": "Rated voltage: 0.38-0.66kV",
                "1": "Rated frequency: 50Hz",
                "2": "Rated capacity: 1-600kvar",
                "3": "Max allowed current: 1.3 times the rated current",
                "4": "Control circuit: 1-16 circuits",
                "5": "Switching time: 1-150S per time",
                "6": "Operating mode: Automatic, continuous operation"
            }
        },
        "5": {
            "name": "Low Voltage Withdrawable Switchgear",
            "model": "GCS",
            "category": "Switchgear",
            "duration": "3 days",
            "updateDate": "27 Sept, 2023",
            "shortDescription": "GCS Low Voltage Withdrawable Switchgear is well-suited for power plants and high-rises. It offers a comprehensive solution for distributing power effectively.",
            "intro": "The GCS-type low-voltage withdrawable switchgear is suitable for power distribution systems in industries such as power plants, oil and gas, chemicals, metallurgy, textiles, and high-rise buildings. In large power plants, petrochemical systems, and other places with a high degree of automation that require interfacing with computers, it serves as a complete low-voltage power distribution device used in power generation and supply systems with a three-phase AC frequency of 50 (60) Hz, rated working voltages of 400V and 660V, and rated currents up to 5000A. It is utilized for power distribution, centralized motor control, and reactive power compensation.",
            "condition": {
                "0": "Ambient air temperature should not exceed +40℃, and not go below -5℃. The average temperature within 24 hours should not exceed +35℃. If exceeded, capacity operation must be reduced based on the actual situation.",
                "1": "For indoor use.",
                "2": "The installation site's altitude should not exceed 2000m.",
                "3": "The surrounding air's relative humidity should not exceed 50% when the temperature is at its highest of +40℃. A higher relative humidity is permissible at lower temperatures, e.g., 90% at +20℃. The potential for occasional condensation due to temperature fluctuations should be considered.",
                "4": "When installing the device, the inclination relative to the vertical plane should not exceed 5°, and the entire cabinet row should be relatively level (compliant with GBJ232-82 standards).",
                "5": "The device should be installed in locations without severe vibrations or impacts and where electrical components are not at risk of undesired corrosion.",
                "6": "For any special requirements, users can consult and customize solutions with our company."
            },
            table: {
                headers: ["Serial No.", "Parameter Name", "Value"],
                rows: [
                    ["1", "Main Circuit Rated Voltage (V)", "AC 400/660"],
                    ["2", "Auxiliary Circuit Rated Voltage", "AC 220, 380 (400), DC 110, 220"],
                    ["3", "Rated Frequency (Hz)", "50 (60)"],
                    ["4", "Rated Insulation Voltage (V)", "660"],
                    ["5", "Rated Current (A) - Horizontal Bus", "≤5000"],
                    ["", "Rated Current (A) - Vertical Bus (MCC)", "1000"],
                    ["6", "Busbar Rated Short-Time Withstand Current (KA/1s)", "50, 80"],
                    ["7", "Busbar Rated Peak Withstand Current (KA/0.1s)", "105, 176"],
                    ["8", "Power-Frequency Test Voltage (V/1min) - Main Circuit", "2500"],
                    ["", "Power-Frequency Test Voltage (V/1min) - Auxiliary Circuit", "2000"],
                    ["9", "Busbar - Three-Phase Four-Wire System", "A.B.C.PEN"],
                    ["", "Busbar - Three-Phase Five-Wire System", "A.B.C.PE.N"],
                    ["10", "Protection Level", "IP30, IP40"],
                ],
            },
        },
        "6": {
            "name": "Dry-type Transformer",
            "model": "SCB11",
            "category": "Transformer",
            "duration": "7 days",
            "updateDate": "27 Sept, 2023",
            "shortDescription": "Our dry-type transformers excel in safety and efficiency, ideal for high-rises, airports, ports, and CNC machinery.",
            "intro": "Ideal for local lighting, high-rise buildings, airports, ports, and CNC machinery, our dry-type transformers offer safety, efficiency, and ease of use.",
            "features": {
                "0": "Safe, fire-resistant, pollution-free, and can be directly operated at the load center.",
                "1": "Adopts domestic advanced technology, high mechanical strength, strong short-circuit resistance, minimal partial discharge, good thermal stability, high reliability, and long service life.",
                "2": "Low loss, low noise, evident energy-saving effects, and maintenance-free.",
                "3": "Good heat dissipation performance, strong overload capacity; forced air cooling can enhance the operational capacity.",
                "4": "Good moisture resistance, suitable for operation in high humidity and other harsh environments.",
                "5": "Dry-type transformers are equipped with a comprehensive temperature detection and protection system. The intelligent signal temperature control system can automatically detect and display the working temperature of each phase winding and can automatically start and stop the fan. It also has settings for alarms, tripping, and other functions.",
                "6": "Compact in size, lightweight, requires minimal installation space, and has low installation costs."
            },
            "condition": {
                "0": "Operating temperature: 0-40°C.",
                "1": "Relative humidity: <70%.",
                "2": "Altitude: No higher than 2,500 meters.",
                "3": "Avoid operation in environments with corrosive liquids, gases, dust, conductive fibers, or a significant amount of metal shavings.",
                "4": "Avoid operation in locations with vibrations or electromagnetic interference.",
                "5": "Avoid prolonged upside-down storage and transportation; avoid strong impacts."
            },
            "technicalParameters": {
                "0": "Operating frequency: 50 / 60HZ.",
                "1": "No-load current: < 4%.",
                "2": "Dielectric strength: 20,000V/min without breakdown; Testing instrument: YZ1802 Dielectric Strength Tester (20mA).",
                "3": "Insulation class: Class F (customizable for special grades).",
                "4": "Insulation resistance: ≥2M Ohms; Testing instrument: ZC25B-4 Megohmmeter (<1000 V).",
                "5": "Connection methods: Y/Y, △/Y0, Yo/△, Auto-transformer type (optional).",
                "6": "Allowable temperature rise of the coil: 100K.",
                "7": "Cooling method: Natural air cooling or temperature-controlled automatic cooling.",
                "8": "Noise level: ≤30dB."
            }
        },
        "7": {
            "name": "Oil-immersed Transformer",
            "model": "S11",
            "category": "Transformer",
            "duration": "7 days",
            "updateDate": "27 Sept, 2023",
            "shortDescription": "Our oil-immersed transformers reliably convert voltage for end-users, built for indoor/outdoor use and harsh conditions.",
            "intro": "Our oil-immersed transformers are perfect for transforming voltage, commonly from 10kv or 35kv down to 380V or 220V for end-user applications. Suitable for both indoor and outdoor settings, they are built to withstand harsh conditions.",
            "features": {
                "0": "For oil-immersed power transformers, the low-voltage winding typically adopts a cylindrical structure made of copper foil winding, except for those with smaller capacities, which use copper wire.",
                "1": "The high-voltage winding employs a multi-layer cylindrical structure, ensuring uniform turn distribution, minimal leakage magnetism, high mechanical strength, and strong resistance to short circuits.",
                "2": "The iron core and winding are securely fastened separately. The device's high-voltage section, low-voltage leads, and other fastening parts are equipped with self-locking nuts to prevent them from coming loose. It uses a coreless structure to withstand the bumps during transportation.",
                "3": "The coil and iron core undergo vacuum drying treatment, and transformer oil is filled using vacuum oil filtration technology, significantly minimizing the moisture inside the oil-immersed power transformer.",
                "4": "The oil tank utilizes a corrugated sheet that has a breathing feature, compensating for oil volume changes due to temperature fluctuations. As a result, this product doesn't have an oil storage tank, significantly reducing the transformer's height.",
                "5": "Because the corrugated sheet replaces the oil storage tank, the transformer oil is isolated from the external environment, effectively preventing the ingress of oxygen and water, which could degrade insulation performance.",
                "6": "Based on the above points, there's no need to change the oil of the oil-immersed power transformer during normal operation, greatly reducing maintenance costs and extending the transformer's service life."
            },
            "condition": {
                "0": "Maximum altitude: ≤1500 meters;",
                "1": "Maximum wind speed: 35M/S;",
                "2": "Altitude: no more than 2500 meters;",
                "3": "Maximum relative humidity: ≤90% (at 25℃);",
                "4": "Highest ambient temperature: +45℃;",
                "5": "Average temperature in the hottest month: +30℃;",
                "6": "Lowest ambient temperature: -40℃;",
                "7": "Maximum daily temperature difference: 25℃;",
                "8": "Ice coverage: 10MM;",
                "9": "Seismic ground horizontal acceleration: 0.3g;",
                "10": "Pollution level: Class IV."
            },
            "technicalParameters": {
                "0": "Rated capacity: 50-2000kVA",
                "1": "Rated voltage: 10KV or 35KV",
                "2": "Voltage adjustment: Off-circuit or semi-automatic",
                "3": "Insulation grade: F"
            }
        },
        // "8": {
        //     "name": "Indoor Voltage Transformer",
        //     "model": "JDZX9-10",
        //     "category": "CT&PT",
        //     "duration": "7-15 days",
        //     "updateDate": "17 Jan, 2024",
        //     "shortDescription": "Indoor Epoxy Resin Voltage Transformer, Lightweight and Efficient.",
        //     "intro": "This indoor voltage transformer is an epoxy resin casting full enclosed full insulating product. It is used for voltage measuring, electric energy metering and relay protection. Small size and lightweight, there are secondary terminal box, wiring is convenient.",
        //     "features": {
        //         "0": "Utilizes advanced epoxy resin material to ensure complete sealing and insulation, enhancing safety.",
        //         "1": "Compact design, small in size, facilitates easy installation and space-saving.",
        //         "2": "Lightweight design, easy to handle and install, reducing installation costs.",
        //         "3": "Equipped with a secondary terminal box, simplifying the wiring process and improving installation efficiency.",
        //         "4": "Provides accurate and reliable data for voltage measurement, electric energy metering, and relay protection.",
        //         "5": "Durable and stable for long-term operation, reducing maintenance costs."
        //     },
        //     "technicalParameters": {
        //         "0": "Rated insulation level: 12/42/75kV",
        //         "1": "Rated frequency: 50/60Hz",
        //         "2": "Power factor: COSφ=0.8(lag)",
        //         "3": "Standard: GB20840.1(2,3,4)"
        //     }
        // },
        "9": {
            "name": "LZZW-10 Current Transformer",
            "model": "LZZW-10",
            "category": "CT&PT",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Outdoor pillar current transformer, epoxy resin encapsulated, suitable for harsh environments",
            "intro": "The LZZW-10 outdoor current transformer features a fully enclosed epoxy resin pillar structure, designed for 10kV and below power systems at 50Hz or 60Hz. Compliant with IEC185 and GB1208-2006 standards, it offers arc resistance, UV protection, and long service life, ideal for energy metering, current measurement, and relay protection.",
            "features": {
                "0": "Epoxy resin fully enclosed pillar structure enhances mechanical strength and insulation safety",
                "1": "Triple protection against arc/UV/aging ensures long-term outdoor stability",
                "2": "Multiple accuracy options (0.5/0.5S/0.2/0.2S/5P10/10P10) for diverse metering scenarios",
                "3": "Red/grey color options available for environmental coordination",
                "4": "Pollution Level IV certified for enhanced reliability in polluted areas",
                "5": "Pillar mounting structure improves mechanical stability"
            },
            "technicalParameters": {
                "0": "Rated voltage: 10kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 5~1000A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 12kV/42kV/75kV",
                "5": "Accuracy class: 0.5/0.5S/0.2/0.2S/5P10/10P10",
                "6": "Burden: 5VA/10VA (customizable)"
            }
        },
        "10": {
            "name": "JDZ9-10G Indoor Voltage Transformer",
            "model": "JDZ9-10G",
            "category": "CT&PT",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Compact indoor voltage transformer, epoxy resin insulated, easy wiring",
            "intro": "The JDZ9-10G indoor voltage transformer employs fully encapsulated epoxy resin construction, designed for non-effectively grounded systems below 10kV. Its compact body with terminal box enables efficient voltage measurement, energy metering and relay protection installations in confined spaces.",
            "features": {
                "0": "Epoxy resin full encapsulation provides dual insulation",
                "1": "Compact design saves 70% installation space",
                "2": "Lightweight body (<5kg) reduces handling difficulty",
                "3": "Terminal box direct connection improves wiring efficiency",
                "4": "0.2-class accuracy ensures ≤±0.2% measurement error"
            },
            "technicalParameters": {
                "0": "Product standard: GB20840.1(2,3,4)",
                "1": "Rated insulation level: 7.2kV/32kV/60kV, 12kV/42kV/75kV",
                "2": "Rated frequency: 50Hz or 60Hz",
                "3": "Phase: Single-phase",
                "4": "Installation: Indoor"
            }
        },
        "11": {
            "name": "JDZX9-10 Indoor Voltage Transformer",
            "model": "JDX9-10",
            "category": "CT&PT",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "High-efficiency indoor voltage transformer, precision monitoring",
            "intro": "This voltage transformer features inverted pouring technology with epoxy resin full-sealed structure ensuring reliable indoor operation. It provides high stability for voltage monitoring, energy metering and relay protection in 10kV and below non-effectively grounded systems.",
            "features": {
                "0": "Inverted pouring technology optimizes internal electric field",
                "1": "Fully insulated structure with no exposed live parts",
                "2": "Compact dimensions (Ø150×180mm)",
                "3": "Terminal protection rating IP54",
                "4": "Temperature adaptive design (-10~40℃)"
            },
            "technicalParameters": {
                "0": "Rated insulation level: 12kV/42kV/75kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Load power factor: cosφ=0.8 (lagging)",
                "3": "Product standard: GB20840.1(2,3,4)"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Ambient temperature: -10℃~40℃",
                "2": "Altitude: ≤1000m",
                "3": "Pollution level: Class Ⅱ"
            }
        },
        "12": {
            "name": "JDZW-10R Voltage Transformer",
            "model": "JDZW-10R",
            "category": "Voltage Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Outdoor voltage transformer, fully sealed moisture-proof design",
            "intro": "The JDZW-10R voltage transformer uses UV-resistant epoxy resin pouring technology, designed specifically for 10kV outdoor environments. With IP55 protection certification, it reliably performs voltage monitoring and relay protection in rainy, foggy and high-humidity conditions.",
            "features": {
                "0": "Outdoor-specific sealing technology for moisture/condensation prevention",
                "1": "Composite silicone rubber sheds increase creepage distance",
                "2": "UV-resistant epoxy resin delays aging",
                "3": "Full-range temperature compensation (-25~50℃)",
                "4": "Dual lightning protection design"
            },
            "technicalParameters": {
                "0": "Rated insulation level: 12kV/42kV/75kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Phase: Single-phase",
                "3": "Product standard: GB20840.1(2,3,4)",
                "4": "Installation: Outdoor pole mounting"
            },
            "condition": {
                "0": "Installation: Outdoor",
                "1": "Ambient temperature: -25℃~50℃",
                "2": "Altitude: ≤2000m",
                "3": "Pollution level: Class Ⅲ"
            }
        },
        "13": {
            "name": "LA-10 Current Transformer",
            "model": "LA-10",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Economical indoor current transformer, epoxy resin protection",
            "intro": "The LA-10 indoor current transformer uses segmented pouring technology, with semi-enclosed design below 200A balancing cost and performance, and fully enclosed structure above 300A ensuring high reliability. Compliant with GB1208-2006 standard for conventional metering and protection.",
            "features": {
                "0": "Segmented structure optimizes cost-effectiveness",
                "1": "Flame-retardant epoxy resin (UL94 V-0 grade)",
                "2": "Wide frequency response (50-2000Hz)",
                "3": "Multi-accuracy configurations (0.5~10P class optional)",
                "4": "Magnetic shielding for strong anti-interference"
            },
            "technicalParameters": {
                "0": "Rated voltage: 10kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 5~2000A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 12kV/42kV/75kV",
                "5": "Product standard: GB20840.1(2,3,4)"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Operating temperature: -10℃~40℃",
                "2": "Altitude: ≤1000m",
                "3": "Structure type: ≤200A semi-enclosed, ≥300A fully enclosed"
            }
        },
        "14": {
            "name": "LAJ-10 Current Transformer",
            "model": "LAJ-10",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Enhanced indoor current transformer, wide temperature adaptation",
            "intro": "This current transformer features stepped structure design, with semi-enclosed insulation below 300A and single-turn/bus-type fully enclosed structure above 400A for high-current applications. Low-temperature epoxy resin formulation supports operation down to -35℃.",
            "features": {
                "0": "Stepped structure adapts to different current ratings",
                "1": "Low-temperature epoxy resin (-35℃ cold-resistant type)",
                "2": "Bus-type design for high current (2000~6000A)",
                "3": "150% In continuous overload capacity",
                "4": "Pollution Level II certified"
            },
            "technicalParameters": {
                "0": "Rated voltage: 10kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 5~6000A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 12kV/42kV/75kV",
                "5": "Short-time withstand current: 40kA/1s"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Operating temperature: -35℃~40℃",
                "2": "Altitude: ≤1000m",
                "3": "Structure type: ≤300A semi-enclosed, 400A-1500A single-turn, ≥2000A bus-type"
            }
        },
        "15": {
            "name": "LZMK-10 Current Transformer",
            "model": "LZMK-10",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Precision measurement current transformer, temperature-optimized",
            "intro": "The LZMK-10 current transformer maintains accuracy stability between -5~40℃ through thermally optimized casting structure. Unique magnetic shunt design ensures composite error ≤0.1%, ideal for high-precision energy metering applications.",
            "features": {
                "0": "Thermally optimized casting, drift <0.005%/℃",
                "1": "Magnetic shunt technology reduces phase error",
                "2": "0.2S class high-precision metering certification",
                "3": "Moisture/condensation protection (humidity ≤95%)",
                "4": "Flame-retardant housing (oxygen index ≥35)"
            },
            "technicalParameters": {
                "0": "Rated voltage: 10kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 5~2000A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 12kV/42kV/75kV",
                "5": "Load power factor: cosφ=0.8 (lagging)",
                "6": "Partial discharge: ≤5pC"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Operating temperature: -5℃~40℃",
                "2": "Altitude: ≤1000m",
                "3": "Structure type: ≤300A semi-enclosed, 400A-1500A single-turn, ≥2000A bus-type"
            }
        },
        "16": {
            "name": "LZZBJ9-10 Current Transformer",
            "model": "LZZBJ9-10",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Multi-function indoor current transformer, adjustable ratio",
            "intro": "This current transformer features secondary winding tap technology supporting three ratio options in one device. Dual-shield windings ensure 0.2S metering and 5P20 protection accuracy simultaneously.",
            "features": {
                "0": "Three-tap winding design, supports ratio switching",
                "1": "Dual-shield windings for metering/protection outputs",
                "2": "Full encapsulation, PD <3pC",
                "3": "Plug-in terminals for easy maintenance",
                "4": "Wide range design (5-400% In)"
            },
            "technicalParameters": {
                "0": "Rated voltage: 10kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 5~1500A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 12kV/42kV/75kV",
                "5": "Ratio options: 3 selectable taps",
                "6": "Short-time current: 50kA/1s"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Operating temperature: -5℃~40℃",
                "2": "Altitude: ≤1000m"
            }
        },
        "17": {
            "name": "LZZBJ9-24 Current Transformer",
            "model": "LZZBJ9-24",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Medium-voltage current transformer for 24kV systems",
            "intro": "Designed specifically for 24kV systems, this fully enclosed current transformer meets medium-voltage grid requirements with enhanced insulation (24kV/65kV/125kV). Cold-resistant elastomer material ensures no cracking at -35℃, suitable for substations in frigid regions.",
            "features": {
                "0": "24kV dedicated insulation design",
                "1": "Cold-resistant elastomer (-35℃ modulus retention)",
                "2": "Dual-sealing structure, waterproof",
                "3": "Short-circuit withstand 60kA/3s",
                "4": "Anti-vibration design (5-200Hz)"
            },
            "technicalParameters": {
                "0": "Rated voltage: 24kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 50~2000A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 24kV/65kV/125kV",
                "5": "Ratio options: 3 selectable taps",
                "6": "Product standard: GB20840.1(2,3,4)"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Operating temperature: -35℃~40℃",
                "2": "Altitude: ≤1000m"
            }
        },
        "18": {
            "name": "LZZBJ9-35 Current Transformer",
            "model": "LZZBJ9-35",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "High-voltage indoor current transformer, 35kV system solution",
            "intro": "The LZZBJ9-35 high-voltage current transformer uses layered pouring technology to achieve 40.5kV/95kV/185kV insulation level. Built-in SF6 pressure compensation ensures metering accuracy at high altitudes (≤4000m).",
            "features": {
                "0": "35kV high-voltage insulation",
                "1": "Pressure compensation design (for ≤4000m altitude)",
                "2": "Shielding electrode optimizes field distribution",
                "3": "Partial discharge ≤3pC (at 1.2Ur)",
                "4": "Digital output supported (optional)"
            },
            "technicalParameters": {
                "0": "Rated voltage: 35kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Rated primary current: 100~3000A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Rated insulation level: 40.5kV/95kV/185kV",
                "5": "Ratio options: 3 selectable taps",
                "6": "Short-time withstand: 63kA/3s"
            },
            "condition": {
                "0": "Installation: Indoor",
                "1": "Operating temperature: -35℃~40℃",
                "2": "Altitude: ≤4000m (special design)"
            }
        },
        "19": {
            "name": "LZW32-12 Inverted Current Transformer",
            "model": "LZW32-12",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Inverted structure outdoor current transformer, 35kV reinforced protection",
            "intro": "This inverted current transformer is designed for 35kV outdoor applications, featuring composite insulation materials for all-weather protection. The unique inverted design lowers the center of gravity, enhancing seismic performance (meets Intensity 8 requirements), especially suitable for earthquake-prone areas.",
            "features": {
                "0": "Inverted structure reduces height by 30%",
                "1": "Dual-sealing process, IP66 protection",
                "2": "Composite silicone rubber sheds, UV/aging resistant",
                "3": "Seismic design (meets GB/T 13540)",
                "4": "35kV system specific, short-circuit withstand 40kA/3s"
            },
            "technicalParameters": {
                "0": "Rated voltage: 35kV",
                "1": "Structure type: Inverted",
                "2": "Rated primary current: 200~2500A",
                "3": "Rated secondary current: 5A or 1A",
                "4": "Installation: Outdoor pillar mounting"
            },
            "condition": {
                "0": "Installation: Outdoor",
                "1": "Operating temperature: -40℃~55℃",
                "2": "Altitude: ≤2000m",
                "3": "Seismic rating: Intensity 8 (0.3g)"
            }
        },
        "20": {
            "name": "LZZW-10 Current Transformer",
            "model": "LZZW-10",
            "category": "Current Transformer",
            "duration": "7-15 days",
            "updateDate": "June 10, 2025",
            "shortDescription": "Heavily polluted area current transformer, Class IV anti-pollution design",
            "intro": "This outdoor current transformer is optimized for high pollution areas like coastal/industrial zones. With Class IV pollution design and extended creepage (≥25mm/kV), it ensures reliable operation. Passed 1000-hour salt fog test, meeting power system requirements in polluted regions.",
            "features": {
                "0": "Class IV pollution design, creepage ≥25mm/kV",
                "1": "Salt-fog resistant structure (1000h no corrosion)",
                "2": "Moisture/condensation protection (humidity ≤100%)",
                "3": "Wind pressure resistance (60m/s wind speed)",
                "4": "Dual lightning protection (10kA impulse)"
            },
            "technicalParameters": {
                "0": "Rated voltage: 10kV",
                "1": "Rated frequency: 50Hz or 60Hz",
                "2": "Pollution level: Class IV",
                "3": "Rated primary current: 5~1000A",
                "4": "Rated secondary current: 5A or 1A",
                "5": "Rated insulation level: 12kV/42kV/75kV",
                "6": "Creepage distance: ≥250mm",
                "7": "Burden: 5VA/10VA/custom",
                "8": "Housing color: Red/Grey"
            },
            "condition": {
                "0": "Installation: Outdoor",
                "1": "Operating temperature: -40℃~40℃ (customizable to -55℃)",
                "2": "Altitude: ≤4000m",
                "3": "Pollution degree: Class IV (NSDD ≤0.4mg/cm²)"
            }
        },
        "21": {
            "name": "KV10 Series Inverter",
            "model": "KV10",
            "category": "Frequency Converter",
            "duration": "7-15 days",
            "updateDate": "July 30, 2025",
            "shortDescription": "Compact, cost-effective AC drive (0.75-2.2kW) optimized for fan, pump, and basic automation motor control with reliable performance and user-friendly operation.",
            "intro": "The KV10 Series is a high-performance compact AC drive engineered for small-to-medium industrial motor control applications. Supporting power ratings from 0.75kW to 7.5kW, it features advanced V/F control, multiple acceleration/deceleration profiles, and comprehensive I/O terminals for flexible configuration. With built-in protection against overvoltage, overcurrent, and overheating, KV10 ensures reliable operation. The intuitive LED keypad enables quick parameter access and clear status monitoring. Supporting MODBUS communication, programmable PID control, and multi-speed operation modes, it integrates sleep/wake logic, intelligent braking functions, and a space-saving 153×53mm design. Ideal for fans, pumps, conveyors, and automation systems, its robust construction and simplified installation make it the preferred choice for OEMs and system integrators requiring cost-effective motor drive solutions.",
            "features": {
                "0": "LED display for real-time operational parameter monitoring",
                "1": "Key lock function with partial/full locking options to prevent misuse",
                "2": "Comprehensive protection including short-circuit, phase-loss, over-current/voltage, and thermal overload protection"
            },
            "table": {
                "headers": [
                    "Inverter Standard Model",
                    "Rated Input Voltage(V)",
                    "Rated Output Power(kW)",
                    "Input Current(A)",
                    "Rated Output Current(A)"
                ],
                "rows": [
                    ["KV10-0D57G-4", "Three-Phase 380V", "0.75kW", "3.4", "2.1"],
                    ["KV10-1D5G-4", "Three-Phase 380V", "1.5kW", "5", "3.8"],
                    ["KV10-2D2G-4", "Three-Phase 380V", "2.2kW", "5.8", "5"]
                ]
            },
            "technicalParameters": {
                "0": "Maximum Frequency:0~400Hz",
                "1": "Carrier Frequency:2kHz~16kHz (automatically adjusts based on load characteristics)",
                "2": "Input Frequency Resolution: Digital setting 0.01Hz; Analog setting Maximum frequency ×0.025%",
                "3": "Starting Torque: G-type machine; 0.5HZ/150%(SVC)",
                "4": "Speed Range:1:100(SVC)",
                "5": "Speed Stabilization Accuracy:±0.5%(SVC)",
                "6": "Overload Capacity: G-type: 150% rated current 60s; 180% rated current 3s",
                "7": "Torque Boost Range: Manual 0.1%~30.0%",
                "8": "V/F Curve: Linear/Multi-point/Nth-power (1.2~2 powers)",
                "9": "Acceleration/Deceleration Time Range:0.0~6500.0s",
                "10": "DC Braking: Frequency 0~MaxHz, Time 0-36s, Current 0~100%",
                "11": "Jog Frequency Range:0.00~50.00Hz",
                "12": "Timing Control Range:0.0~6500.0 minutes",
                "13": "Command Source: Operator panel/Control terminals/Serial communication",
                "14": "Frequency Source: 10 types (digital/analog voltage/analog current/pulse/serial)",
                "15": "Auxiliary Frequency Source: 10 types for frequency fine-tuning and synthesis",
                "16": "Input Terminals: 4 digital inputs + 1 analog input (0~10V)",
                "17": "Output Terminals: 1 multi-function + 1 relay + 1 analog output (0~20mA/0~10V)",
                "18": "Built-in PID: Enables process control closed-loop systems",
                "19": "Overvoltage/Overcurrent Stall Control: Prevents frequent tripping",
                "20": "Fast Current Limiting: Minimizes overcurrent faults",
                "21": "Virtual I/O: Five virtual DIDOs for logic control",
                "22": "Modbus Fieldbus Support",
                "23": "Operator Panel Parameter Display",
                "24": "Application Environment: Indoor dust-free setting",
                "25": "Braking Resistor Short-Circuit Protection"
            },
            "condition": {
                "0": "Application Environment: Indoor, avoid direct sunlight, dust/corrosive gases/oil mist/moisture-free",
                "1": "Altitude: <1000m",
                "2": "Operating Temperature: -10℃~+40℃ (derating required at 40~50℃)",
                "3": "Operating Humidity: <95%RH (no condensation)",
                "4": "Vibration: <5.9m/s²(0.6g)",
                "5": "Storage Temperature: -20℃~+60℃"
            }
        },
        "22": {
            "name": "KV65M(E) High-Protection Frequency Converter",
            "model": "KV65M",
            "category": "Frequency Converter",
            "duration": "7-15 days",
            "updateDate": "19 Aug, 2025",
            "shortDescription": "IP65-rated inverter for harsh industrial environments with 1500Hz vector control and ±0.02% speed stability",
            "intro": "The KV65M (E) high protection inverter is a dedicated AC motor driver designed for harsh industrial environments. Its core feature is the IP65 protection rating, capable of withstanding rain, dust, humidity, water spray, metal dust, and corrosive gases under extreme conditions. It ensures stable operation in scenarios where conventional inverters cannot function properly.",
            "technicalParameters": {
                "0": "Max Frequency: Vector:0.00~1500.00Hz / V/F:0.00~650.00Hz",
                "1": "Carrier Frequency: 0.8kHz~16kHz (auto-adjusted per load)",
                "2": "Input Resolution: Digital 0.01Hz; Analog: MaxFreq×0.025%",
                "3": "Control Methods: Sensorless Vector (SVC)/V/F",
                "4": "Starting Torque: G-type: 0.25Hz/150%(SVC)",
                "5": "Speed Range: 1:200 (SVC); 1:1000 (FVC)",
                "6": "Speed Stability: ±0.5% (SVC); ±0.02% (FVC)",
                "7": "Torque Precision: ±5% (SVC >5Hz); ±3% (FVC)",
                "8": "Overload Capacity: G-type: 150% rated current 60s",
                "9": "Torque Boost: Auto/Manual 0.1%~30.0%",
                "10": "V/F Curve: Linear/Multi-point/Full V-F separation/Partial V-F separation",
                "11": "V/F Separation: Full/Half modes",
                "12": "Accel/Decel: Linear/S-curve; Time:0.0~6500.0s",
                "13": "DC Braking: Freq 0-MaxHz; Current 0-100%; Time 0~36s",
                "14": "Jog Control: Freq 0-50Hz; Accel time 0~6500s",
                "15": "Multi-speed: 16-step via PLC/terminals",
                "16": "Built-in PID: Closed-loop process control",
                "17": "AVR: Maintains constant output during voltage fluctuations",
                "18": "Stall Prevention: Auto current/voltage limiting",
                "19": "Fast Current Limit: Custom threshold setting"
            },
            "features": {
                "0": "IP65 protection: Dust/water/corrosion resistance",
                "1": "1500Hz high-frequency vector control",
                "2": "±0.02% industrial-grade speed stability",
                "3": "16-step speed operation modes",
                "4": "Motor overheating protection technology",
                "5": "Full auto voltage compensation"
            },
            "table": {
                "headers": [
                    "Model",
                    "Rated Input Voltage",
                    "Rated Power(kW)",
                    "Input Current(A)",
                    "Rated Output Current(A)"
                ],
                "rows": [
                    ["KV65M(E)-2D2G-4", "3-Phase 380V", "2.2", "6.3", "5.0"],
                    ["KV65M(E)-3D0G-4", "3-Phase 380V", "3.0", "9.3", "7.5"],
                    ["KV65M(E)-4D0G-4", "3-Phase 380V", "3.7", "11.4", "9.0"],
                    ["KV65M(E)-5D5G-4", "3-Phase 380V", "5.5", "15.0", "13.0"],
                    ["KV65M(E)-7D5G-4", "3-Phase 380V", "7.5", "20.0", "17.0"],
                    ["KV65M(E)-011G-4", "3-Phase 380V", "11.0", "32.0", "25.0"],
                    ["KV65M(E)-015G-4", "3-Phase 380V", "15.0", "40.0", "32.0"],
                    ["KV65M(E)-018G-4", "3-Phase 380V", "18.5", "45.0", "40.0"]
                ]
            },
            "condition": {
                "0": "Protection Class: IP65 (dust/water proof)",
                "1": "Applications: CNC machines/Wire drawing/Pumps/Aerators",
                "2": "Environment: Resists metal dust/corrosive gases/water spray"
            }
        },
        "23": {
            "name": "KV90M Series Heavy-Duty Frequency Converter",
            "model": "KV90M",
            "category": "Frequency Converter",
            "duration": "15-30 days",
            "updateDate": "August 19, 2025",
            "shortDescription": "0.75~630kW industrial-grade drive with 1500Hz vector control and ±0.02% speed stability for demanding applications",
            "intro": "The KV90M series heavy-duty inverter features industrial-grade components and 0.75~630kW power range. Equipped with advanced vector control technology supporting 1500Hz operation and ±0.02% speed accuracy. Independent air duct cooling, IP20 protection, and industry-specific macros (pumps/fans/cranes) ensure reliable performance in high-inertia applications with extended service life.",
            "features": {
                "0": "1500Hz high-frequency vector control",
                "1": "±0.02% industrial speed stability",
                "2": "10+ protection functions with OV/OC suppression",
                "3": "Independent air duct + derating design",
                "4": "16-step speed control + industry macros",
                "5": "Heavy-duty construction for 840HP"
            },
            "table": {
                "headers": ["Output Voltage", "Details", "Current(A)", "Overall Dimensions H(mm)", "Overall Dimensions W(mm)", "Overall Dimensions D(mm)", "Mounting Dimensions A(mm)", "Mounting Dimensions B(mm)"],
                "rows": [
                    ["220V, Three phase", "KV90MS-0D75G-1", "5", "200", "90", "140", "75", "187"],
                    ["220V, Three phase", "KV90MS-1D5G-1", "7", "200", "90", "140", "75", "187"],
                    ["220V, Three phase", "KV90MS-2D2G-1", "10", "200", "90", "140", "75", "187"],
                    ["220V, Three phase", "KV90MS-4D0G-1", "17", "240", "125", "170", "110", "225"],
                    ["380V, Three phase", "KV90MS-0D75G-4", "2.7", "200", "90", "140", "75", "187"],
                    ["380V, Three phase", "KV90MS-1D5G-4", "3.7", "200", "90", "140", "75", "187"],
                    ["380V, Three phase", "KV90MS-2D2G-4", "5", "200", "90", "140", "75", "187"],
                    ["380V, Three phase", "KV90MS-3D0G-4", "7", "205", "105", "165", "90", "190"],
                    ["380V, Three phase", "KV90MS-4D0G-4", "9", "205", "105", "165", "90", "190"],
                    ["380V, Three phase", "KV90MS-5D5G-4", "13", "205", "105", "165", "90", "190"],
                    ["380V, Three phase", "KV90MS-7D5G-4", "110", "205", "105", "165", "90", "190"],
                    ["380V, Three phase", "KV90M-7D5G/011P-4", "17", "240", "125", "170", "110", "225"],
                    ["380V, Three phase", "KV90M-011G/015P-4", "25", "240", "125", "170", "110", "225"],
                    ["380V, Three phase", "KV90M-015G/018P-4", "32", "295", "165", "205", "145", "280"],
                    ["380V, Three phase", "KV90M-018G/022P-4", "37", "295", "165", "205", "145", "280"],
                    ["380V, Three phase", "KV90M-022G/030P-4", "45", "360", "235", "225", "205", "340"],
                    ["380V, Three phase", "KV90M-030G/037P-4", "60", "360", "235", "225", "205", "340"],
                    ["380V, Three phase", "KV90M-037G/045P-4", "75", "420", "255", "210", "95", "405"],
                    ["380V, Three phase", "KV90M-045G/055P-4", "90", "420", "255", "210", "95", "405"],
                    ["380V, Three phase", "KV90M-055G/075P-4", "110", "610", "265", "280", "200", "590"],
                    ["380V, Three phase", "KV90M-075G/090P-4", "150", "610", "265", "280", "200", "590"],
                    ["380V, Three phase", "KV90M-090G/110P-4", "176", "620", "320", "300", "260", "600"],
                    ["380V, Three phase", "KV90M-110G/132P-4", "210", "620", "320", "300", "260", "600"],
                    ["380V, Three phase", "KV90M-132G/160P-4", "250", "800", "380", "315", "260", "780"],
                    ["380V, Three phase", "KV90M-160G/185P-4", "300", "800", "380", "315", "260", "780"],
                    ["380V, Three phase", "KV90M-185G/200P-4", "340", "900", "480", "350", "180 * 2", "880"],
                    ["380V, Three phase", "KV90M-200G/220P-4", "380", "900", "480", "350", "180 * 2", "880"],
                    ["380V, Three phase", "KV90M-220G/250P-4", "415", "900", "480", "350", "180 * 2", "880"],
                    ["380V, Three phase", "KV90M-250G/280P-4", "470", "1060", "650", "350", "265 * 2", "1040"],
                    ["380V, Three phase", "KV90M-280G/315P-4", "520", "1060", "650", "350", "265 * 2", "1040"],
                    ["380V, Three phase", "KV90M-315G/350P-4", "600", "1060", "650", "350", "265 * 2", "1040"],
                    ["380V, Three phase", "KV90M-350G-4", "640", "1200", "860", "350", "370 * 2", "1180"],
                    ["380V, Three phase", "KV90M-400G-4", "490", "1200", "860", "350", "370 * 2", "1180"],
                    ["380V, Three phase", "KV90M-500G-4", "860", "1350", "1000", "390", "420 * 2", "1330"],
                    ["380V, Three phase", "KV90M-600G-4", "1100", "1350", "1000", "390", "420 * 2", "1330"]
                ]
            },
            "table2": {
                "headers": ["Parameter Category", "Parameter Name", "Specification"],
                "rows": [
                    ["Frequency Characteristics", "Maximum Frequency", "Vector Control: 0.00~1500.00Hz<br>V/f Control: 0.00~650.00Hz"],
                    ["", "Carrier Frequency", "0.8kHz~16kHz (auto-adjusted)"],
                    ["", "Input Resolution", "Digital: 0.01Hz<br>Analog: MaxFreq×0.025%"],
                    ["Control Features", "Control Methods", "Sensorless Vector (SVC)<br>V/f Control"],
                    ["", "Starting Torque", "G-type: 0.25Hz/150%(SVC)"],
                    ["Performance", "Speed Range", "1:200 (SVC)<br>1:1000 (FVC)"],
                    ["", "Speed Stability", "±0.5% (SVC)<br>±0.02% (FVC)"],
                    ["", "Torque Precision", "±5% (SVC >5Hz)<br>±3% (FVC)"],
                    ["", "Overload Capacity", "150% rated current 60s"],
                    ["Function Settings", "Torque Boost", "Auto/Manual (0.1%-30.0%)"],
                    ["", "V/F Curves", "Linear<br>Multi-point<br>Full V/F Separation<br>Partial V/F Separation"],
                    ["", "V/F Separation", "Full<br>Half"],
                    ["Operation Control", "Accel/Decel Profiles", "Linear/S-curve"],
                    ["", "Accel/Decel Times", "4 groups (0.0s~6500.0s)"],
                    ["", "DC Braking", "Frequency:0.00Hz~Max Hz<br>Current:0.0%~100.0%<br>Time:0.0s~36.0s"],
                    ["", "Jog Control", "Freq range:0.00Hz~50.00Hz<br>Time:0.0s~6500.0s"],
                    ["Advanced Functions", "Multi-speed Operation", "Up to 16 steps (PLC/terminals)"],
                    ["", "Built-in PID", "Closed-loop process control"],
                    ["", "AVR", "Constant output during grid fluctuations"],
                    ["Protections", "Stall Prevention", "Auto current/voltage limiting"],
                    ["", "Fast Current Limiting", "Custom threshold setting"]
                ]
            },
            "condition": {
                "0": "Protection Class: IP20 (indoor)",
                "1": "Temp Range: -10℃~+50℃ (derate 2%/℃ above 40℃)",
                "2": "Altitude: <1000m (derate 1%/100m)",
                "3": "Humidity: 20~95%RH (condensation-free)",
                "4": "Cooling: Forced air with independent duct"
            }
        },
        "24": {
            "name": "JLSZY-10W Outdoor High Voltage Measuring Combined Transformer",
            "model": "JLSZY-10W",
            "category": "Voltage Transformer",
            "duration": "7-15 days",
            "updateDate": "September 29, 2025",
            "shortDescription": "An improved high-voltage dry-type combined transformer made of vacuum-cast insulating resin, featuring arc/UV/aging resistance. Ideal for energy metering in 15kV AC systems and unattended substations, compliant with IEC61869.",
            "intro": "This type of high-voltage dry-type combined transformer is improved on the basis of similar products, and is made of vacuum casting of imported special insulating resin. It has the characteristics of arc resistance, ultraviolet resistance, aging resistance, and long life. It is suitable for active and reactive energy metering in AC power system with rated frequency of 50/60Hz and rated voltage of 15kV. Particularly suitable for unattended, oil-free small substations, product performance meets the requirements of IEC61869 standard.",
            "features": {
                "0": "Made of vacuum-cast imported special insulating resin for arc, UV, and aging resistance.",
                "1": "High precision and dynamic thermal stability, with low magnetic density and overvoltage resistance.",
                "2": "Secondary winding taps allow for different current ratios.",
                "3": "Compact, lightweight, and easy to install with a secure, anti-theft wiring protection box.",
                "4": "Ideal for energy metering in 15kV systems, especially in unattended, oil-free small substations."
            },
            "technicalParameters": {
                "0": "Made of outdoor special epoxy resin vacuum casting.",
                "1": "High dynamic thermal stability, high precision, low magnetic density, and overvoltage resistance.",
                "2": "Secondary winding of the current transformer has taps to obtain different current ratios.",
                "3": "Includes a wiring protection box at the secondary outlet end for safe, reliable, and anti-theft wiring.",
                "4": "Features four mounting holes on the base channel steel for installation."
            },
            "condition": {
                "0": "Installation site: Outdoor and indoor dual use.",
                "1": "Ambient temperature: -15~+55℃, average daily temperature does not exceed 35℃.",
                "2": "Altitude: ≤1000m",
                "3": "Air relative humidity: Monthly average ≤90%; Daily average ≤95%.",
                "4": "Wind speed: ≤ 35m/s.",
                "5": "Atmospheric conditions: No explosion risk, violent vibration, or corrosive dust/vapor."
            }
        },
        "25": {
            "name": "JLSZY-35W Outdoor High Voltage Measuring Combined Transformer",
            "model": "JLSZY-35W",
            "category": "Combined Transformer",
            "duration": "7-15 days",
            "updateDate": "September 29, 2025",
            "shortDescription": "An improved high-voltage dry-type combined transformer made of vacuum-cast insulating resin, featuring arc/UV/aging resistance. Ideal for energy metering in 35kV AC systems and unattended substations, compliant with IEC61869.",
            "intro": "This type of high-voltage dry-type combined transformer is improved on the basis of similar products, and is made of vacuum casting of imported special insulating resin. It has the characteristics of arc resistance, ultraviolet resistance, aging resistance, and long life. It is suitable for active and reactive energy metering in AC power system with rated frequency of 50/60Hz and rated voltage of 35kV. Particularly suitable for unattended, oil-free small substations, product performance meets the requirements of IEC61869 standard.",
            "features": {
                "0": "Made of vacuum-cast imported special insulating resin for arc, UV, and aging resistance.",
                "1": "High precision and dynamic thermal stability, with low magnetic density and overvoltage resistance.",
                "2": "Secondary winding taps allow for different current ratios.",
                "3": "Compact, lightweight, and easy to install with a secure, anti-theft wiring protection box.",
                "4": "Ideal for energy metering in 35kV systems, especially in unattended, oil-free small substations."
            },
            "technicalParameters": {
                "0": "This product consists of a combination of multiple single-phase transformers.",
                "1": "Made of outdoor special epoxy resin vacuum casting.",
                "2": "High dynamic thermal stability, high precision, low magnetic density, and overvoltage resistance.",
                "3": "Secondary winding of the current transformer has taps to obtain different current ratios.",
                "4": "Includes a wiring protection box at the secondary outlet end for safe, reliable, and anti-theft wiring.",
                "5": "Features four mounting holes on the base channel steel for installation."
            },
            "condition": {
                "0": "Installation site: Outdoor and indoor dual use.",
                "1": "Ambient temperature: -15~+55℃, average daily temperature does not exceed 35℃.",
                "2": "Altitude: ≤1000m",
                "3": "Air relative humidity: Monthly average ≤90%; Daily average ≤95%.",
                "4": "Wind speed: ≤ 35m/s.",
                "5": "Atmospheric conditions: No explosion risk, violent vibration, or corrosive dust/vapor."
            }
        },
        "26": {
            "name": "Single Phase ON/Off-Grid Solar Inverter",
            "model": "INV 3600-24",
            "category": "Inverter",
            "duration": "7-15 days",
            "updateDate": "November 26, 2025",
            "shortDescription": "Single-phase hybrid inverter with WiFi monitoring.",
            "intro": "The INV3600-24 is a single-phase hybrid inverter for smart home energy management. It integrates solar panels (5kW max), grid power, a generator, and lithium/lead-acid batteries. With built-in WiFi, it enables remote monitoring and control via an app, managing energy flow from multiple sources to power household loads efficiently.",
            "features": {
                "0": "LCD display.",
                "1": "Support Built-in 80A solar charger, Wide MPPT range: 120-500V.   MAX.PV: 5kW",
                "2": "Support Lithium/Lead-acid battery, support lithium battery activation.",
                "3": "Support WIFI monitoring.",
                "4": "Support workable with generator."
            }
        },
        "27": {
            "name": "Single Phase Off-Grid Solar Inverter",
            "model": "INV 1200-12",
            "category": "Inverter",
            "duration": "7-15 days",
            "updateDate": "November 26, 2025",
            "shortDescription": "Single-phase off-grid inverter with PV charging.",
            "intro": "The INV 1200-12 is a pure sine wave single-phase off-grid inverter with a power factor of 1.0. It converts solar energy, supporting PV charging (60A, 18-125V), and is compatible with lithium/lead-acid batteries, including activation function. Featuring an LCD display, it provides stable off-grid power for home loads.",
            "features": {
                "0": "LCD display.",
                "1": "Support Built-in 60A solar charger, Wide MPPT range: 18-125V.",
                "2": "Support Lithium/Lead-acid battery, support lithium battery activation.",
                "3": "Pure Sine Wave.",
                "4": "Power factor: 1.0"
            }
        },
        "28": {
            "name": "Single Phase ON/Off-Grid Solar Inverter",
            "model": "INV 6000-48",
            "category": "Inverter",
            "duration": "7-15 days",
            "updateDate": "November 26, 2025",
            "shortDescription": "Single-phase hybrid inverter with parallel capability and WiFi monitoring.",
            "intro": "The INV 6000-48 is a high-performance single-phase hybrid inverter supporting solar charging (80A, 120-500V, 9kW) and lithium/lead-acid batteries. With WiFi monitoring and generator connectivity, it allows parallel operation of up to 9 units, delivering reliable on/off-grid power for household loads.",
            "features": {
                "0": "Support Built-in 80A solar charger, Wide MPPT range: 120-500V.   MAX.PV: 9kW",
                "1": "Support Lithium/Lead-acid battery, support lithium battery activation.",
                "2": "Support WIFI monitoring.",
                "3": "Support workable with generator.",
                "4": "Support Feed-in grid, Max.9 inverters in parallel."
            }
        },
        "29": {
            "name": "SVC Series Single-Phase High-Precision Automatic AC Voltage Regulator",
            "model": "SVC",
            "category": "Voltage Regulator",
            "duration": "7-15 days",
            "updateDate": "November 26, 2025",
            "shortDescription": "Single-phase high-precision automatic AC voltage regulator, 220V±3%, efficiency>98%",
            "intro": "The SVC series single-phase high-precision automatic AC voltage regulator consists of a contact autotransformer, servo motor, and automatic control circuit. When grid voltage is unstable or load changes, it automatically and quickly adjusts the output voltage to the rated value (220V±3%) with a response time of <1 second. Featuring no waveform distortion, high efficiency (>98%), and long-term operation capability, it offers comprehensive protection functions including time delay, overvoltage, and undervoltage protection, suitable for various applications requiring stable voltage.",
            "features": {
                "0": "High-precision voltage stabilization, output 220V±3%",
                "1": "Fast response, adjustment time <1 second",
                "2": "High efficiency operation, efficiency >98%",
                "3": "No waveform distortion",
                "4": "Complete protection functions (over/undervoltage, delay)",
                "5": "Wide input voltage range (150V-264V)"
            },
            "table": {
                "headers": ["Model", "Input Voltage (V)", "Output Voltage (V)", "Frequency (Hz)", "Adjusting Time (s)", "Efficiency (%)"],
                "rows": [
                    ["SVC-500VA~10kVA", "150~250", "220±3%", "50/60", "<1", ">98"],
                    ["SVC-15kVA~50kVA", "176~264", "220±3%", "50/60", "<1", ">98"]
                ]
            },
            "table2": {
                "headers": ["Parameter Category", "Parameter Name", "Parameter Value"],
                "rows": [
                    ["Basic Parameters", "Input Voltage", "SVC-500VA~10kVA: 150V~250V; SVC-15kVA~50kVA: 176~264V"],
                    ["", "Output Voltage", "220V±3%, 110V±3%"],
                    ["", "Frequency", "50/60Hz"],
                    ["Performance", "Adjusting Time", "<1 second (when input voltage changes by 10%)"],
                    ["", "Efficiency", ">98%"],
                    ["", "Waveform Distortion", "No additional waveform distortion"],
                    ["Protection", "Overvoltage Protection", "246V±4V"],
                    ["", "Undervoltage Protection", "Yes"],
                    ["", "Time Delay Protection", "Yes"],
                    ["Environment", "Operating Temperature", "-5℃ ~ +40℃"],
                    ["", "Relative Humidity", "<90%"]
                ]
            },
            "condition": {
                "0": "Protection Level: IP20 (indoor installation)",
                "1": "Operating Temperature: -5℃ ~ +40℃",
                "2": "Relative Humidity: <90%RH (non-condensing)",
                "3": "Installation Altitude: <1000m"
            }
        },
        "30": {
            "name": "TNS Series High-Precision Automatic Three-Phase AC Voltage Regulator",
            "model": "TNS",
            "category": "Voltage Regulator",
            "duration": "7-15 days",
            "updateDate": "November 28, 2025",
            "shortDescription": "Three-phase high-precision AC voltage regulator, 380V±3%, efficiency>98%",
            "intro": "The TNS series high-precision automatic three-phase AC voltage regulator consists of three single-phase SVC regulators, employing three-phase independent regulation to ensure voltage stability for each phase. With three-phase four-wire star connection input and configurable three-phase four-wire/three-wire output, it features three ammeters for phase current monitoring and a voltage meter with change-over switch for line voltage detection. Units above 20kVA use autotransformer design, offering fast response (<1 second), high efficiency (>98%), and no waveform distortion, suitable for three-phase equipment voltage stabilization.",
            "features": {
                "0": "Three-phase independent regulation for voltage stability",
                "1": "Wide input voltage range (270V-456V)",
                "2": "High-precision output 380V±3%",
                "3": "Fast response, adjustment time <1 second",
                "4": "High efficiency >98%, energy saving",
                "5": "Flexible three-phase four-wire/three-wire output"
            },
            "table": {
                "headers": ["Model Range", "Input Voltage (V)", "Output Voltage (V)", "Phase", "Frequency (Hz)", "Efficiency (%)"],
                "rows": [
                    ["TNS-6kVA~30kVA", "270~430", "380±3%", "Three-phase", "50/60", ">98"],
                    ["TNS-40kVA~100kVA", "304~456", "380±3%", "Three-phase", "50/60", ">98"]
                ]
            },
            "table2": {
                "headers": ["Parameter Category", "Parameter Name", "Parameter Value"],
                "rows": [
                    ["Basic Parameters", "Input Voltage", "TNS-6kVA~30kVA: 270~430V; TNS-40kVA~100kVA: 304~456V"],
                    ["", "Output Voltage", "380V±3%"],
                    ["", "Phase Number", "Three-phase"],
                    ["", "Frequency", "50/60Hz"],
                    ["Performance", "Adjusting Time", "<1 second (when input voltage changes by 10%)"],
                    ["", "Efficiency", ">98%"],
                    ["", "Waveform Distortion", "No additional waveform distortion"],
                    ["System Configuration", "Input Connection", "Three-phase four-wire, star (Y) connection"],
                    ["", "Output Connection", "Three-phase four-wire or three-wire"],
                    ["", "Structure above 20kVA", "Three corresponding single-phase regulators"],
                    ["Environment", "Operating Temperature", "-5℃ ~ +40℃"],
                    ["", "Relative Humidity", "<90%"]
                ]
            },
            "condition": {
                "0": "Protection Level: IP20 (indoor installation)",
                "1": "Operating Temperature: -5℃ ~ +40℃",
                "2": "Relative Humidity: <90%RH (non-condensing)",
                "3": "Installation Altitude: <1000m"
            }
        },
        "31": {
            "name": "SBW Series Three-Phase Automatic Compensation Power Voltage Regulator",
            "model": "SBW",
            "category": "Voltage Regulator",
            "duration": "10-20 days",
            "updateDate": "November 28, 2025",
            "shortDescription": "Three-phase compensated voltage regulator, large capacity, high efficiency",
            "intro": "The SBW series three-phase automatic compensation voltage regulator automatically maintains stable output voltage during grid fluctuations or load changes. Featuring large capacity, high efficiency (≥95%), no waveform distortion, and smooth voltage regulation, it suits various loads and withstands double rated current for one minute. With manual/automatic switching and multiple protections including overvoltage, overcurrent, phase loss, and phase sequence, it responds quickly (≤1.5s) with adjustable 2-5% output precision for reliable operation.",
            "features": {
                "0": "Large capacity design for wide load applications",
                "1": "High efficiency voltage stabilization ≥95%, no waveform distortion",
                "2": "Withstands double rated current instant overload",
                "3": "Fast response time ≤1.5 seconds",
                "4": "Adjustable 2-5% output precision, stable regulation",
                "5": "Multiple protections (overvoltage, overcurrent, phase loss, sequence)"
            },
            "table": {
                "headers": ["Parameter Type", "Parameter Value"],
                "rows": [
                    ["Input Voltage", "3-phase 4-wire: 175-265V(phase)/304-456V(line)"],
                    ["Output Voltage", "Three-phase 380V"],
                    ["Output Precision", "2-5% adjustable"],
                    ["Frequency", "50/60Hz"],
                    ["Efficiency", "≥95%(power≥50kVA)"],
                    ["Response Time", "≤1.5s"]
                ]
            },
            "table2": {
                "headers": ["Parameter Category", "Parameter Name", "Parameter Value"],
                "rows": [
                    ["Basic Parameters", "Input Voltage", "3-phase 4-wire: 175-265V(phase), 304-456V(line)"],
                    ["", "Output Voltage", "Three-phase 380V"],
                    ["", "Output Precision", "2-5%, adjustable"],
                    ["", "Frequency", "50/60Hz"],
                    ["Performance", "Efficiency", "≥95% (power rating ≥50kVA)"],
                    ["", "Response Time", "≤1.5s"],
                    ["", "Waveform Distortion", "No additional waveform distortion"],
                    ["Protection", "Overload Capacity", "Double rated current, 1 minute"],
                    ["", "Protection Functions", "Overvoltage, overcurrent, phase loss, phase sequence"],
                    ["", "Insulation Resistance", "5MΩ"],
                    ["Environment", "Operating Temperature", "-5℃ ~ +40℃"]
                ]
            },
            "condition": {
                "0": "Protection Level: IP20 (indoor installation)",
                "1": "Operating Temperature: -5℃ ~ +40℃",
                "2": "Insulation Resistance: ≥5MΩ",
                "3": "Installation: Fixed installation"
            }
        },
        "32": {
            "name": "All-in-One Inverter 3.6KW 8KWH Energy Storage Battery System",
            "model": "ESS 3.6KW+8KWH",
            "category": "Inverter",
            "duration": "10-20 days",
            "updateDate": "January 7, 2026",
            "shortDescription": "3.6kW inverter with 8kWh battery integrated storage system, built-in MPPT solar charger, grid-tie and WiFi monitoring supported.",
            "intro": "The ESS 3.6KW+8KWH is a highly integrated all-in-one energy storage system, combining an inverter, battery management system (BMS), and an MPPT solar charger. It supports up to 5kW PV input with a wide operating voltage range (40-450VDC). The unit supports grid-tie operation and features WiFi remote monitoring with an intuitive large-screen display. Equipped with multiple communication interfaces, it enables intelligent charge/discharge management for multiple lithium batteries, offering an efficient and convenient energy storage solution for home or commercial use.",
            "features": {
                "0": "Highly integrated inverter and BMS design, compact structure",
                "1": "Built-in high-efficiency MPPT solar charger, max. PV power 5kW",
                "2": "Supports grid-tie operation for feed-in",
                "3": "WiFi smart monitoring supported with large LCD display",
                "4": "Multiple communication interfaces (RS485, dry contact) for battery expansion and management",
                "5": "Pure sine wave output, fast transfer time (10ms), works as online UPS"
            },
            "table": {
                "headers": ["Parameter Category", "Core Specifications"],
                "rows": [
                    ["Rated AC Power", "3.6 kW"],
                    ["Surge Power", "5.7 kVA"],
                    ["Rated Battery Capacity", "8 kWh"],
                    ["AC Output Voltage", "208/220/230/240 VAC"],
                    ["Max. PV Input", "5 kW / 8A"],
                    ["MPPT Voltage Range", "40-450 VDC"],
                    ["Battery Voltage", "25.6 VDC (20-29.2V)"],
                    ["Max. Efficiency (Battery Mode)", "92.7%"]
                ]
            },
            "table2": {
                "headers": ["Parameter Category", "Parameter Name", "Specification"],
                "rows": [
                    ["AC Input", "Rated Input Voltage", "208/220/230/240 VAC; L+N+PE"],
                    ["", "Voltage Range (Normal Mode)", "90~280±3 VAC"],
                    ["", "Voltage Range (UPS Mode)", "170~280±3 VAC"],
                    ["", "Frequency", "50/60 Hz (Auto Adaptive)"],
                    ["AC Output", "Rated Capacity", "3.6 kW"],
                    ["", "Surge Power", "5.7 kVA"],
                    ["", "Output Voltage", "208/220/230/240 VAC"],
                    ["", "Power Factor (PF)", "1"],
                    ["", "Output Frequency", "50/60Hz±0.1%"],
                    ["", "Transfer Time", "10 ms"],
                    ["", "Wave Form", "Pure Sine Wave"],
                    ["PV/AC Charger", "Solar Charger Type", "MPPT"],
                    ["", "Max. PV Input Current/Power", "8A / 5000W"],
                    ["", "MPPT Operating Voltage Range", "40~450 VDC"],
                    ["", "Max. PV Open Circuit Voltage", "500 VDC"],
                    ["", "Max. PV Charge Current", "100 A"],
                    ["", "Max. AC Charge Current", "100 A"],
                    ["", "Max. Charge Current (PV+AC)", "100 A"],
                    ["Battery", "Nominal Battery Voltage", "25.6 VDC"],
                    ["", "Rated Energy", "8 kWh (0.2C, 25℃)"],
                    ["", "Usable Energy (90% DOD)", "8 kWh"],
                    ["", "Max. Charge/Discharge Current", "75A / 150A"],
                    ["", "Operation Voltage Range", "20Vdc ~ 29.2 Vdc"],
                    ["Interface & Environment", "Display", "LCD"],
                    ["", "Communication", "USB, RS485, Dry Contact"],
                    ["", "Monitoring", "WiFi"],
                    ["", "Ingress Protection (IP)", "IP20"],
                    ["", "Operating Temperature", "-10℃ ~ +50℃"],
                    ["", "Storage Temperature", "-15℃ ~ +60℃"],
                    ["", "Max. Operating Altitude", "4000m (Derating above 1000m)"]
                ]
            },
            "condition": {
                "0": "Protection Level: IP20 (for indoor installation)",
                "1": "Operating Temperature: -10℃ ~ +50℃",
                "2": "Operating Humidity: 5% ~ 95% RH (Non-condensing)",
                "3": "Max. Operating Altitude: 4000m (Derating required above 1000m)"
            }
        },
        "33": {
            "name": "All-in-One Inverter & Battery System 6KW+16KWH",
            "model": "ESS 6KW+16KWH",
            "category": "Inverter",
            "duration": "10-20 days",
            "updateDate": "January 7, 2026",
            "shortDescription": "6kW inverter with 16kWh battery, supports 9kW PV and grid-tie.",
            "intro": "The ESS 6KW+16KWH is a high-power all-in-one inverter and energy storage system, integrating the inverter and BMS. It features a built-in high-efficiency MPPT solar charger supporting up to 9kW PV input with an 80-520VDC operating range. The system supports grid-tie operation and WiFi remote monitoring, equipped with an LCD screen. Tower front-end wiring terminals ensure easy installation. With multiple communication interfaces like RS485 and dry contacts, it enables intelligent charge/discharge management for multiple lithium batteries, ideal for residential and commercial energy storage.",
            "features": {
            "0": "Highly integrated inverter and BMS for system stability and reliability",
            "1": "Built-in MPPT solar charger, max. PV power 9kW, wide voltage range 80-520VDC",
            "2": "Supports grid-tie operation for bi-directional energy flow",
            "3": "WiFi smart monitoring supported with a large LCD display for intuitive operation",
            "4": "Tower front-end wiring terminal design for easy installation and maintenance",
            "5": "Multiple communication interfaces (RS485, dry contact) for battery expansion and intelligent management"
            },
            "table": {
            "headers": ["Parameter Category", "Core Specifications"],
            "rows": [
            ["Rated AC Power", "6 kW"],
            ["Surge Power", "12 kVA"],
            ["Rated Battery Capacity", "16 kWh"],
            ["AC Output Voltage", "208/220/230/240 VAC"],
            ["Max. PV Input", "9 kW (19A+19A)"],
            ["MPPT Voltage Range", "80-520 VDC"],
            ["Nominal Battery Voltage", "51.2 VDC"],
            ["Max. Efficiency (Battery Mode)", "93%@48VDC"]
            ]
            },
            "table2": {
            "headers": ["Parameter Category", "Parameter Name", "Specification"],
            "rows": [
            ["AC Input", "Rated Input Voltage", "208/220/230/240; L+N+PE"],
            ["", "Voltage Range (Normal Mode)", "90~280±3 VAC"],
            ["", "Voltage Range (UPS Mode)", "170~280±3 VAC"],
            ["", "Frequency", "50/60 Hz (Auto Adaptive)"],
            ["AC Output", "Rated Capacity", "6 kW"],
            ["", "Surge Power", "12 kVA"],
            ["", "Voltage", "208/220/230/240 VAC"],
            ["", "Power Factor (PF)", "1"],
            ["", "Frequency", "50/60Hz±0.1%"],
            ["", "Switch Time", "10 ms"],
            ["", "Wave Form", "Pure Sine Wave"],
            ["Charger (PV/AC)", "Solar Charger Type", "MPPT"],
            ["", "Max PV input current/power", "19A+19A / 9000W"],
            ["", "Operating Voltage Range (VDC)", "80~520 VDC"],
            ["", "Max PV Open Circuit Voltage (VDC)", "500 VDC"],
            ["", "Max PV Charge Current (A)", "120 A"],
            ["", "Max AC Charge Current (A)", "120 A"],
            ["", "Max. Charge Current (PV+AC) (A)", "120 A"],
            ["Battery", "Nominal Battery Voltage", "51.2 VDC"],
            ["", "Rated Energy", "16 KWh (0.5C, 25°C)"],
            ["", "Usable Energy (90% DOD)", "16 KWh"],
            ["", "Max. Charge/Discharge Current", "100A / 150A"],
            ["", "Operation Voltage Range", "40.5Vdc ~ 54.5 Vdc"],
            ["", "Operation Temperature", "-10°C ~ +50°C"],
            ["Interface & General", "Display", "LCD"],
            ["", "Communication", "USB"],
            ["", "Monitoring", "WiFi"],
            ["", "Ingress Protection", "IP20"],
            ["", "Operating Temperature", "-10°C ~ 50°C"],
            ["", "Relative Humidity", "5% ~ 95% (Non-condensing)"],
            ["", "Storage Temperature", "-15°C ~ 60°C"],
            ["", "Max.Operating Altitude", "4000m (Derating above 1000m)"]
            ]
            },
            "condition": {
            "0": "Protection Level: IP20 (for indoor installation)",
            "1": "Operating Temperature: -10℃ ~ +50℃",
            "2": "Operating Humidity: 5% ~ 95% RH (Non-condensing)",
            "3": "Max. Operating Altitude: 4000m (Derating required above 1000m)"
            }
            },
            "34": {
                "name": "Pure Sine Wave Integrated Inverter & Battery System 12KW 30KWH All in One",
                "model": "ESS 12KW+30KWH",
                "category": "Inverter",
                "duration": "10-20 days",
                "updateDate": "January 7, 2026",
                "shortDescription": "12kW inverter with 30kWh battery, dual MPPT, dual AC output, grid-tie.",
                "intro": "The ESS 12KW+30KWH is a high-power pure sine wave all-in-one inverter and battery system, integrating inverter and BMS with grid-tie capability. It features dual AC output channels and built-in dual MPPT solar chargers supporting up to 12kW PV input. Compatible with generator connection, it offers WiFi remote monitoring and convenient tower front-end wiring. With multiple communication interfaces (RS485/RS232/USB/Dry Contact), it enables intelligent management of multiple lithium batteries, meeting high-power residential and commercial energy storage needs.",
                "features": {
                "0": "Highly integrated inverter and BMS, supporting grid-tie and generator input",
                "1": "Dual AC output for multiple load power supply requirements",
                "2": "Built-in dual MPPT solar chargers, max. PV power 12kW, wide voltage range 90-485VDC",
                "3": "WiFi smart monitoring with large LCD display for intuitive operation",
                "4": "Tower front-end wiring terminal design for easy installation and maintenance",
                "5": "Rich communication interfaces (RS485/RS232/USB/Dry Contact) for system integration and battery management"
                },
                "table": {
                "headers": ["Parameter Category", "Core Specifications"],
                "rows": [
                ["Rated AC Power", "12 kW"],
                ["Surge Power", "18 kVA"],
                ["Rated Battery Capacity", "30.72 kWh"],
                ["AC Output Voltage", "120/240 VAC (Dual Output)"],
                ["Max. PV Input", "12 kW (22A+22A)"],
                ["MPPT Voltage Range", "90-485 VDC"],
                ["Nominal Battery Voltage", "51.2 VDC"],
                ["Max. Efficiency (Battery Mode)", ">95%"]
                ]
                },
                "table2": {
                "headers": ["Parameter Category", "Parameter Name", "Specification"],
                "rows": [
                ["AC Input", "Rated Input Voltage", "120(L1/N, L2/N) 240(L1/L2)"],
                ["", "Voltage Range", "(85~140) ±2%"],
                ["", "Frequency", "50Hz/60Hz (Auto detection)"],
                ["AC Output", "Rated Capacity", "12 kW"],
                ["", "Surge Power", "18 kVA"],
                ["", "Voltage", "120(L1/N, L2/N) 240(L1/L2)"],
                ["", "Power Factor (PF)", "1"],
                ["", "Frequency", "50/60Hz±0.1%"],
                ["", "Switch Time", "10 ms"],
                ["", "Wave Form", "Pure Sine Wave"],
                ["", "Overload Protection", "(105%<load<110%): Shut off after 5 min; (110%<load<125%): Shut off after 10 sec; load>125%: Shut off after 5 sec"],
                ["Charger (PV/AC)", "Solar Charger Type", "Dual MPPTs"],
                ["", "Max PV input current/power", "22A+22A / 6kW+6kW"],
                ["", "Operating Voltage Range (VDC)", "90Vdc ~ 485Vdc"],
                ["", "Max PV Open Circuit Voltage (VDC)", "500Vdc"],
                ["", "Max PV Charge Current (A)", "220 A"],
                ["", "Max AC Charge Current (A)", "160 A"],
                ["", "Max. Charge Current (PV+AC) (A)", "0-220 A"],
                ["Battery", "Nominal Battery Voltage", "51.2 VDC"],
                ["", "Rated Energy", "30.72 kWh (0.5C, 25°C)"],
                ["", "Usable Energy (90% DOD)", "30 kWh"],
                ["", "Max. Charge/Discharge Current", "200A / 200A"],
                ["", "Operation Voltage Range", "44.8Vdc ~ 58.4Vdc"],
                ["", "Operation Temperature", "-10°C ~ +50°C"],
                ["Interface & General", "Display", "LCD"],
                ["", "Communication", "RS485/RS232/USB/Dry Contact"],
                ["", "Monitoring", "WiFi"],
                ["", "Ingress Protection", "IP21"],
                ["", "Operating Temperature", "-10°C ~ 50°C"],
                ["", "Relative Humidity", "5% ~ 95% (Non-condensing)"],
                ["", "Storage Temperature", "-15°C ~ 60°C"],
                ["", "Max. Operating Altitude", "4000m (Derating above 1000m)"]
                ]
                },
                "condition": {
                "0": "Protection Level: IP21 (indoor installation, protected against vertically falling water)",
                "1": "Operating Temperature: -10℃ ~ +50℃",
                "2": "Operating Humidity: 5% ~ 95% RH (Non-condensing)",
                "3": "Max. Operating Altitude: 4000m (Derating required above 1000m)"
                }
                },
                "35": {
                    "name": "Three Phase Low Voltage All-in-One Inverter & Battery System ESS LV 15KW+64KWH",
                    "model": "ESS LV 15KW+64KWH",
                    "category": "Inverter",
                    "duration": "15-30 days",
                    "updateDate": "January 8, 2026",
                    "shortDescription": "Three-phase low voltage energy storage system, 15kW/64kWh, 400V input/output, supports 18kW PV.",
                    "intro": "The ESS LV 15KW+64KWH is a three-phase low-voltage all-in-one energy storage system, integrating inverter and BMS with grid-tie capability. It features a built-in MPPT solar charger supporting up to 18kW PV input with an 80-520VDC operating range. The system uses 400V three-phase AC input and output, compatible with lithium or lead-acid batteries (up to 16 parallel for lithium). Equipped with WiFi remote monitoring and an LCD screen, it is suitable for industrial and commercial energy storage applications requiring three-phase power supply.",
                    "features": {
                    "0": "Highly integrated inverter and BMS design, supporting grid-tie operation",
                    "1": "Built-in MPPT solar charger, max. PV power 18kW, wide voltage range 80-520VDC",
                    "2": "400V three-phase AC input and output for industrial and commercial scenarios",
                    "3": "WiFi smart monitoring with large LCD display",
                    "4": "Compatible with lithium or lead-acid batteries, up to 16 parallel for lithium, flexible expansion",
                    "5": "Large capacity energy storage, rated energy 64kWh, usable energy 57.6kWh"
                    },
                    "table": {
                    "headers": ["Parameter Category", "Core Specifications"],
                    "rows": [
                    ["Rated AC Power", "15 kW"],
                    ["Surge Power", "18 kVA"],
                    ["Rated Battery Capacity", "64 kWh"],
                    ["AC Input/Output Voltage", "400V /3L+N+PE"],
                    ["Max. PV Input", "18 kW (9kW+9kW)"],
                    ["MPPT Voltage Range", "80-520 VDC"],
                    ["Nominal Battery Voltage", "51.2 VDC"],
                    ["Max. Efficiency (Battery Mode)", "93%@48VDC"]
                    ]
                    },
                    "table2": {
                    "headers": ["Parameter Category", "Parameter Name", "Specification"],
                    "rows": [
                    ["AC Input", "Rated Input Voltage", "400V /3L+N+PE"],
                    ["", "Voltage Range", "400V / -20% ~ +15%"],
                    ["", "Frequency", "50Hz/60Hz (Auto adaptive)"],
                    ["AC Output", "Rated Capacity", "15 kW"],
                    ["", "Surge Power", "18 kVA"],
                    ["", "Voltage", "400V / -20% ~ +15%"],
                    ["", "Power Factor (PF)", "1"],
                    ["", "Frequency", "50/60Hz±0.1%"],
                    ["", "Switch Time", "10 ms"],
                    ["", "Wave Form", "Pure Sine Wave"],
                    ["", "Overload capacity (Battery Mode)", "60s@102%~110%; 10s@110%~130%; 3s@130%~150%; 0.2s@>150%"],
                    ["Charger (PV/AC)", "Solar Charger Type", "MPPT"],
                    ["", "Max PV input current/power", "9000W+9000W"],
                    ["", "Operating Voltage Range (VDC)", "80~520 VDC"],
                    ["", "Max PV Open Circuit Voltage (VDC)", "500Vdc"],
                    ["", "Max PV Charge Current (A)", "200 A"],
                    ["", "Max AC Charge Current (A)", "160 A"],
                    ["", "Max. Charge Current (PV+AC) (A)", "200 A"],
                    ["Battery", "Nominal Battery Voltage", "51.2 VDC"],
                    ["", "Rated Energy", "64 kWh (0.5C, 25°C)"],
                    ["", "Usable Energy (90% DOD)", "57.6 kWh"],
                    ["", "Max. Charge/Discharge Current", "400A / 400A"],
                    ["", "Operation Voltage Range", "40.5Vdc ~ 58.4Vdc"],
                    ["", "Operation Temperature", "-10°C ~ +50°C"],
                    ["Interface & General", "Display", "LCD"],
                    ["", "Communication", "USB"],
                    ["", "Monitoring", "WiFi"],
                    ["", "Battery Type", "Lithium or Lead-acid battery, up to 16 parallel for lithium"],
                    ["", "Ingress Protection", "IP20"],
                    ["", "Operating Temperature", "-10°C ~ 50°C"],
                    ["", "Relative Humidity", "5% ~ 95% (Non-condensing)"],
                    ["", "Storage Temperature", "-15°C ~ 60°C"],
                    ["", "Max. Operating Altitude", "4000m (Derating above 1000m)"]
                    ]
                    },
                    "condition": {
                    "0": "Protection Level: IP20 (for indoor installation)",
                    "1": "Operating Temperature: -10℃ ~ +50℃",
                    "2": "Operating Humidity: 5% ~ 95% RH (Non-condensing)",
                    "3": "Max. Operating Altitude: 4000m (Derating required above 1000m)"
                    }
                    },
                    "36": {
                        "name": "Portable Energy Storage Battery System Pure Sine Wave Inverter All-in-One 1KWH 500W",
                        "model": "ESS 500W+1000WH",
                        "category": "Inverter",
                        "duration": "7-15 days",
                        "updateDate": "January 8, 2026",
                        "shortDescription": "500W portable power station with 1kWh LiFePO4 battery, supports solar charging.",
                        "intro": "The ESS 500W+1000WH is a portable all-in-one inverter and energy storage system, integrating the inverter and BMS with a LiFePO4 battery that offers up to 8000 cycles. It provides 500W pure sine wave AC output (185-230VAC) and a 5V/1A USB DC output. Supports dual charging via utility (max 500W) and solar (max 300W, MPPT range 10-55VDC). Equipped with RS485 communication, dry contact interfaces, and LED status indicators. With noise below 40dB, it is ideal for outdoor emergency, camping, and mobile power needs.",
                        "features": {
                        "0": "Highly integrated inverter and BMS design, compact and portable",
                        "1": "Long-life LiFePO4 battery with up to 8000 cycles",
                        "2": "Supports dual charging from utility and solar (MPPT range 10-55VDC)",
                        "3": "Provides 500W pure sine wave AC output and 5V USB DC output",
                        "4": "Multiple interfaces including RS485 communication and dry contact for expansion and management",
                        "5": "Comprehensive circuit protection, low operating noise (<40dB)"
                        },
                        "table": {
                        "headers": ["Parameter Category", "Core Specifications"],
                        "rows": [
                        ["Rated AC Output Power", "500W"],
                        ["Battery Rated Capacity", "1004.8 Wh (~1kWh)"],
                        ["Output Voltage Waveform", "Pure Sine Wave"],
                        ["Output Voltage/Frequency", "185~230VAC / 50Hz"],
                        ["Solar Charging Power", "300W Max"],
                        ["Total Charging Power (Utility+Solar)", "500W Max"],
                        ["Battery Type", "LiFePO4 Battery (3.2Vdc)"],
                        ["Cycle Life", "Up to 8000 cycles"]
                        ]
                        },
                        "table2": {
                        "headers": ["Parameter Category", "Parameter Name", "Specification"],
                        "rows": [
                        ["AC Output", "Rated AC Output Power", "500W"],
                        ["", "Output Voltage Waveform", "Pure Sine Wave"],
                        ["", "Output Voltage", "185~230VAC 50Hz"],
                        ["Battery Protection", "Low DC Warning Point", "≤19%"],
                        ["", "Low DC Cut-off Voltage", "2.9Vdc"],
                        ["", "Low DC Warning Return Voltage", ">20%"],
                        ["Charging Parameters", "Charging Power (Utility and Solar)", "500W Max"],
                        ["", "Bulk Charging Voltage", "3.6Vdc"],
                        ["", "Float Charging Voltage", "3.5Vdc"],
                        ["", "Max. Pulse Discharge Current", "300A for 1Sec"],
                        ["AC Input", "Nominal Input Voltage", "230Vac"],
                        ["", "Low Loss Voltage", "90Vac±7"],
                        ["", "Low Loss Return Voltage", "100Vac±7"],
                        ["", "High Loss Voltage", "280Vac±7"],
                        ["", "High Loss Return Voltage", "270Vac±7"],
                        ["", "Max. AC Input Voltage", "300Vac"],
                        ["", "Nominal input Frequency", "45~65Hz"],
                        ["", "AC Charging Power", "500W Max"],
                        ["Solar Input", "Nominal PV Voltage", "30Vdc"],
                        ["", "PV Array MPPT Voltage Range", "10Vdc~55Vdc"],
                        ["", "Max. PV Array Open Circuit Voltage", "56Vdc"],
                        ["", "Solar Charging Power", "300W Max."],
                        ["Lithium Iron Battery", "Capacity", "1004.8Wh"],
                        ["", "Nominal Battery Voltage", "3.2Vdc"],
                        ["", "Typical Capacity", "314Ah"],
                        ["", "Max. Charge Current", "220A"],
                        ["", "Max. Discharge Current", "220A"],
                        ["", "Operation Voltage Range", "2.9Vdc~3.6Vdc"],
                        ["", "Operation Temperature", "-10℃~+50℃"],
                        ["DC Output & Display", "DC Output Power", "5W Max"],
                        ["", "DC Output Socket", "1pcs 5V 1A USB charger"],
                        ["", "LED Indicator", "4pcs SOC indicators, 1pcs working status indicator"],
                        ["Ambient", "Noise (at 1 meter)", "<40dB"],
                        ["", "Working Temperature", "-10℃~+50℃"],
                        ["", "Humidity", "5~95% (no condensation)"],
                        ["", "Sea Level", "≤2000m"]
                        ]
                        },
                        "condition": {
                        "0": "Operating Temperature: -10℃ ~ +50℃",
                        "1": "Operating Humidity: 5% ~ 95% RH (non-condensing)",
                        "2": "Max. Operating Altitude: ≤2000m",
                        "3": "Noise Level: <40dB (at 1 meter from the unit)"
                        }
                        }
},
    productsText: {
        discuss: "Have products in mind? Let's discuss",
        touch: "Get in touch with us to see how we can help you with your project"
    },
    blog: {
        "1blog": {
            "title": "Ximai Electrical Introduction",
            "tags": {
                "Introduction": "Introduction"
            },
            "description": [
                "Hubei Ximai Electrical Equipment Co. , Ltd (abbreviated as 'Ximai Electrical') was established in 2006 with registered capital of 20 million RMB. The company has over 100 employees, of which more than 90% are engaged in technological production and R&D.",
                "As knowledge-intensive innovative company of strong technical force, and based on talents and technology advantages, Ximai electrical mainly manufactures type SH15, S13, S11 and SCB11 transformers, box - type substation, KYN28 High - voltage switch-cabinet, GCS, GGD, GGJ, power supply cabinet, distribution box, and iron accessory equipment, as well as engaging in general contracting for electrical engineering projects. Product quality management system in line with the ISO9001, environmental management system in line with ISO14001, occupational health and safety management system in line with OHSAS18001, CCC certification, and have passed the National Quality Supervision and Inspection center's qualified test, and we own a patent.",
                "The products have met the State Grid Hubei Electric Power Company's standard, verifying our company's ability of being their qualified supplier. We were awarded as 'Contract - keeping and Credit First Company of E'zhou city in 2011', 'Contract - keeping and Credit First Company of Hubei Province in 2010 - 2011', 'Consumer Satisfaction with the Goods in 2011 - 2012', 'Contract - keeping and Credit First Company of E'zhou city in 2012 - 2013', 'Contract - keeping and Credit First Company of Hubei Province in 2014'. Meanwhile, our brand was honored as 'Well - known Trademark of E'zhou City from 2014 - 2018', and 'Famous Trademark of Hubei Province from 2014 - 2019'.",
                "Through the introduction of advanced concepts, the use of sophisticated technology, our company gets successful results in the State Grid tender projects: such as the State Grid Hubei Electric Power Company's first supermarket - style centralized procurement (iron fittings and bolts) in 2015, the State Grid Hubei Electric Power Company's power distribution network equipment protocol stock (new batch), the State Grid En'Shi Electric Power Company's selenium tea City II (25 - 36 F #) power supply engineering (material procurement and supervision), Hubei Electric power company's peak summer emergency repair works of rural network in 2012, Hubei Electric power company's rural power project, Hubei Electric power company's supporting project for the new residential construction from November 2011 to November 2012, Hubei Electric power company's power distribution network project for rural power upgrading of Suizhou city in 2011, Hubei Electric power company's supporting project for new residential construction and project for urban low-voltage distribution network from December 2010 to December 2011, Hubei Electric power company's fifth batch rural power upgrading project (network distribution) for Guangshui, Suizhou city in 2010. The equipment's operation conditions have obtained the user's universal acclaim.",
                "Guided by the principle of 'based in China while serve the whole world', and combined with market demand, Ximai Electrical concentrates on new product development, product structure optimizing, energy conservation and environmental protection. Providing new, energy - saving, environmentally friendly products is our unswerving pursuit. With 'safety first, quality-oriented, customer first' as our aim, we strive to establish good reputation and provide integrity services.",
                "Welcome your arrival and instruction, and all the staff of Ximai Electrical await your presence!"
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Explore Ximai Electrical through our introduction video, know more about Ximai and the decision of ensuring the quality of products.",
            "blockquote": "",
            "create_at": "15 APR, 2020",
            "blClass": "format-video"
        },
        "2blog": {
            "title": "Specialized Electrical Supply for Lingkong District People's Hospital",
            "tags": {
                "Medical_Infrastructure": "Medical Infrastructure",
                "Electrical_Engineering": "Electrical Engineering",
                "Urban_Development": "Urban Development"
            },
            "description": [
                "We are proud to announce our recent collaboration with the Lingkong District People's Hospital, where we have undertaken the specialized electrical supply project. Ensuring consistent and efficient power supply to healthcare institutions is of paramount importance. With state-of-the-art machinery and critical patient care systems relying heavily on electricity, a robust and reliable power infrastructure becomes a cornerstone of modern healthcare.",
                "Our experienced team has meticulously designed and implemented a power supply system that aligns with the unique needs of the hospital. From emergency rooms to operating theaters, we have ensured that each department receives an uninterrupted power supply, minimizing risks and elevating patient care standards.",
                "This venture signifies our deep commitment to enhancing public health infrastructure. We understand the challenges of urban healthcare facilities and are dedicated to providing solutions that meet the high standards expected of modern medical establishments.",
                "As we look forward to more collaborations in the future, our endeavor with Lingkong District People's Hospital stands as a testament to our expertise and commitment to community welfare."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Empowering healthcare with specialized electrical solutions. At the heart of medical excellence is robust infrastructure.",
            "blockquote": "",
            "create_at": "11 AUG, 2021",
            "blClass": "format-standard-image"
        },
        "3blog": {
            "title": "Power Distribution Renovation at Ezhou No.1 Hospital",
            "tags": {
                "Infrastructure_Upgrade": "Infrastructure Upgrade",
                "Medical_Infrastructure": "Medical Infrastructure"
            },
            "description": [
                "We are immensely honored to announce our recent involvement in the power distribution renovation project at the Ezhou No.1 Hospital.",
                "Our dedicated and skilled team embarked on this project with a clear vision - to enhance the efficiency and reliability of the hospital's electrical system. Through meticulous planning, cutting-edge solutions, and an unwavering commitment to excellence, we have successfully elevated the hospital's power distribution to new heights.",
                "Such projects underline the importance of a robust and efficient electrical system, especially in healthcare settings where uninterrupted power is crucial. With a history of successfully completed projects, our team was well-poised to undertake this responsibility. We worked in close collaboration with the hospital's management, ensuring minimal disruption to their operations. The upgraded electrical system now not only promises efficient power distribution but also offers better safety, durability, and future readiness.",
                "We recognize the vital role power distribution plays in the smooth running of such essential institutions and remain dedicated to providing unparalleled service. As always, our endeavors are driven by a commitment to our clients, the community, and the desire to make a meaningful impact.",
                "This achievement serves as a testament to our unwavering dedication and technical prowess. We are deeply grateful to the management of Ezhou No.1 Hospital for entrusting us with this responsibility and look forward to more collaborative efforts in the future."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Delivering unparalleled expertise to power crucial institutions like Ezhou No.1 Hospital.Our commitment to excellence ensures a brighter, safer future for all.",
            "blockquote": "",
            "create_at": "15 APR, 2023",
            "blClass": "format-standard-image"
        },
        "4blog": {
            "title": "Power Capacity Expansion for the Isolation Area at Ezhou University During the COVID-19",
            "tags": {
                "COVID-19": "COVID-19",
                "University_Infrastructure": "University Infrastructure",
                "Electrical_Capacity_Upgrade": "Electrical Capacity Upgrade",
                "Social_Responsibility": "Social Responsibility"
            },
            "description": [
                "We are proud to announce that Hubei Ximai Electrical Equipment Co., Ltd. rose to the occasion during the pandemic by increasing the power capacity for the isolation area at Ezhou University. In times of crisis, our dedication to serving the community truly shines.",
                "With the outbreak of the pandemic, the requirement for power at the university's isolation area surged. Our adept team of professionals, armed with the expertise in power capacity expansion, worked diligently and swiftly to meet these increased demands. It was crucial that the institution could rely on a robust and stable power supply to ensure the smooth running of the isolation area.",
                "We understand the enormous responsibility that such an endeavor holds, particularly during a pandemic. Through meticulous planning, state-of-the-art equipment, and relentless teamwork, we successfully enhanced the power capacity, ensuring the continuous operation of the university's isolation area.",
                "Amid the ever-evolving world of electrical engineering, the need for adaptable, efficient, and resilient solutions is more pressing than ever. Our involvement with Ezhou University's project serves as a testament to our ability to respond to unique challenges promptly and effectively.",
                "Our commitment to serving our clients and the broader community during challenging times remains unwavering. We express our gratitude to Ezhou University for trusting us during these testing times, and we look forward to further collaborative efforts."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Strengthening power capacity, enhancing resilience during challenging times. Hubei Ximai Electrical stands with the community during the pandemic.",
            "blockquote": "",
            "create_at": "25 APR, 2023",
            "blClass": "format-standard-image"
        },
        "5blog": {
            "title": "Street Lighting Project on Binjiang 2nd Road, Ezhou",
            "tags": {
                "Street_Lighting": "Street Lighting",
                "Urban_Infrastructure": "Urban Infrastructure",
                "Urban_Development": "Urban Development"
            },
            "description": [
                "We are immensely proud to have played a pivotal role in the Street Lighting Project on Binjiang 2nd Road in Ezhou, as part of the broader Ezhou Riverside Flood Control Ecological Restoration Project.",
                "Our involvement spanned the gamut of project services – from trench excavation, pole erection, light fixture and accessory installation, to cable laying. Upholding the highest standards of engineering quality and a steadfast commitment to integrity in service, we continually strive to offer our clients top-notch engineering solutions.",
                "Within the scope of this project, we also took on the active responsibility of maintaining and safeguarding client-provided materials and facilities. This encompassed tasks such as site clearance, sludge treatment, and water pumping, ensuring a smooth and successful execution of the project from inception to completion. As we move forward, our dedication remains intact, and we are geared to provide professional and reliable services and support for various engineering projects."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Illuminating the streets of Ezhou with precision and expertise, paving the way for safer, brighter urban spaces.",
            "blockquote": "",
            "create_at": "15 APR, 2023",
            "blClass": "format-standard-image"
        },
        "6blog": {
            "title": "Emergency Electrical Repairs During the COVID-19 Period",
            "tags": {
                "Emergency_Response": "Emergency Response",
                "Electrical_Repairs": "Electrical Repairs",
                "Social_Responsibility": "Social Responsibility",
                "COVID-19": "COVID-19"
            },
            "description": [
                "During the challenging times of the 2020 Covid-19, our company actively participated in emergency electrical repairs, demonstrating our commitment to social responsibility. The pandemic disrupted various facets of daily life, and amidst this chaos, ensuring uninterrupted power supply became more critical than ever before.",
                "Our dedicated team was on the front lines, working diligently to address electrical disruptions and restore normalcy to affected areas. Such actions not only ensured that essential services remained operational but also underscored our company's unwavering dedication to community welfare. As the pandemic raged on, our swift interventions alleviated potential hardships, reinforcing the trust our community has in our expertise and service.",
                "These unparalleled efforts during such unprecedented times speak volumes about our company's ethos, values, and our pledge to rise to any occasion, no matter how challenging."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Powering through adversity, ensuring light during the darkest hours. Our commitment stood unyielding amidst the 2020 pandemic.",
            "blockquote": "",
            "create_at": "6 MAY, 2020",
            "blClass": "format-standard-image"
        },
        "7blog": {
            "title": "Power Distribution Room Renovation at Leishan Hospital During the Pandemic",
            "tags": {
                "COVID-19": "COVID-19",
                "Emergency_Response": "Emergency Response",
                "Social_Responsibility": "Social Responsibility",
                "Medical_Infrastructure": "Medical Infrastructure"
            },
            "description": [
                "During the pandemic, our company heeded the call to action and joined the fight against the virus. We undertook the power distribution room renovation project at Leishan Hospital in Ezhou, providing the hospital with a stable and reliable power supply.",
                "Our professional technical team, after multiple rounds of deliberation and research, designed a comprehensive power distribution solution for the hospital. Adhering strictly to the relevant standards and requirements, we executed the renovation project meticulously. Throughout this process, we became acutely aware of how every healthcare worker's and patient's safety and health relies on the support of a reliable power supply.",
                "Our engineers worked tirelessly, day and night, on the renovation frontlines, ensuring the quality and progress of the project. Our employees always kept the company's social responsibility in mind, practicing the values we have always held with their actions.",
                "We will continue to pay attention to societal issues, respond actively to social calls, and contribute to building a better society."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Amidst a global crisis, our dedication shone through. Our commitment to serve, evident as we powered healthcare facilities and lit the beacon of hope.",
            "blockquote": "",
            "create_at": "18 JUL, 2020",
            "blClass": "format-standard-image"
        },
        "8blog": {
            "title": "Power Distribution Room Renovation at Ezhou No.3 Hospital During the Pandemic",
            "tags": {
                "Crisis_Response": "Crisis Response",
                "Professional_Services": "Professional Services",
                "Medical_Infrastructure": "Medical Infrastructure",
                "COVID-19": "COVID-19",
            },
            "description": [
                "Our company provided comprehensive services for the power distribution room renovation at Ezhou No.3 Hospital, fully embodying the sense of corporate social responsibility. Against the backdrop of the 2020 COVID-19 pandemic, our professional technical team went deep into the hospital site. With a scientific and reasonable power distribution plan and precise construction, we provided the hospital with a stable and reliable power supply.",
                "Our employees overcame various difficulties and challenges brought about by the pandemic, demonstrating the spirit and responsibility of disaster relief and epidemic prevention. The successful implementation of this project not only showcased our professional standards and sense of social responsibility but also strengthened our belief in practicing corporate social responsibility.",
                "We will continue to create greater value for our customers and society with higher standards and more professional services."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "During testing times, we rose to the occasion. Powering healthcare facilities and serving our community, we showcased our unwavering commitment and resilience.",
            "blockquote": "",
            "create_at": "03 AUG, 2020",
            "blClass": "format-standard-image"
        },
        "9blog": {
            "title": "Delivering Coolness: Initiative by Our Project Team",
            "tags": {
                "Social_Responsibility": "Social Responsibility",
                "Employee_Welfare": "Employee Welfare",
            },
            "description": [
                "In the midst of a sweltering summer, our company initiated a 'Delivering Coolness' campaign for the employees of China First Metallurgical Construction Corporation. We provided the employees with refreshing drinks and fresh fruit, bringing a sense of relief and surprise.",
                "Our company has always adhered to a 'people-oriented' service philosophy, putting customer needs and experience first. Through this campaign, we hoped to convey the corporate culture of 'love, care, warmth,' allowing more people to feel our dedication and concern.",
                "We will continue to strive to provide our clients with higher quality services and support, contributing to the construction of a better society."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Cooling off the summer heat, we extended our care and warmth to our employees. Upholding our 'people-first' philosophy, we continue striving for excellence in service.",
            "blockquote": "",
            "create_at": "07 AUG, 2022",
            "blClass": "format-standard-image"
        },
        "10blog": {
            "title": "On-site Emergency Repairs During the COVID-19 Pandemic",
            "tags": {
                "Emergency_Response": "Emergency Response",
                "COVID-19": "COVID-19",
                "Field_Service": "Field Service",
                "Social_Responsibility": "Social Responsibility"
            },
            "description": [
                "During the challenging times of the COVID-19 pandemic in 2021, our team displayed remarkable resilience and commitment. We were at the forefront, providing on-site emergency repair services, ensuring uninterrupted power supply when it was needed the most.",
                "The pandemic brought unforeseen challenges, but our team stood strong. We followed stringent safety protocols and worked tirelessly to keep critical infrastructure running smoothly. These emergency repairs ranged from fixing critical power line issues to restoring and maintaining crucial electrical equipment.",
                "Our field service teams worked round-the-clock, sometimes in harsh and demanding conditions. Their undeterred commitment and expertise ensured minimal downtime and maintained the continuity of essential services.",
                "As a responsible organization, we understand our role in such challenging times. It's our duty to provide uninterrupted service and ensure that electrical failures do not add to the difficulties faced by our community.",
                "We are incredibly proud of our teams who risked their own well-being for the greater good. Their dedication and courage are commendable, and they truly embody the spirit of our company.",
                "Despite the ongoing challenges posed by the pandemic, we remain committed to delivering our services with the same determination and quality. We stand ready to face any future challenges and continue serving our community."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Through resilience and commitment, our team stepped up during the pandemic to ensure uninterrupted power supply. At the frontlines of service, we are ready to face any challenge.",
            "blockquote": "",
            "create_at": "21 MAY, 2021",
            "blClass": "format-standard-image"
        },
        "11blog": {
            "title": "Development of Lingkong Avenue Bus Stop and Trash Can Solutions",
            "tags": {
                "Infrastructure": "Infrastructure",
                "Public_Transportation": "Public Transportation",
                "Urban_Development": "Urban Development"
            },
            "description": [
                "We're elated to unveil our comprehensive contributions to Lingkong Avenue's urban infrastructure, encompassing the Bus Stop and the state-of-the-art Trash Can Solutions. Our expertise in urban development has been showcased in these two critical projects, emphasizing our dedication to enhancing community experiences and environmental sustainability.",
                "The newly designed Lingkong Avenue Bus Stop is a paradigm of modern transportation infrastructure, aiming to provide residents and travelers with an efficient, comfortable, and safe commuting experience. In parallel, our innovative trash can solutions are engineered to handle urban waste effectively, supporting the city's cleanliness and environmental goals.",
                "We believe that robust transportation and sanitation infrastructures play pivotal roles in uplifting urban life quality. Our team's in-depth collaboration with local authorities and stakeholders ensures that these installations not only cater to present-day needs but are also adaptable for future demands.",
                "We remain fervently committed to shaping urban landscapes that are convenient, clean, and sustainable. Our continued association with such transformative projects stands as a testament to our vision and capability. We eagerly anticipate further collaborations to enhance urban life."
            ],
            "author": "Qianyi Yu",
            "authorTitle": "Qianyi Yu",
            "quote": "Crafting a harmonious urban experience with advanced transportation and sanitation solutions.",
            "blockquote": "",
            "create_at": "26 OCT, 2022",
            "blClass": "format-standard-image"
        }
    }
}

export default en_translation;